<template>
  <div>
    <div id="ConsultaDireccion_div" class="container-fluid">
<!--       <div id="TituloConsultaDireccion_div" class="w-100">
        COMENTARIO INICIO  <h1 style="margin-bottom: 0px;">Consulta para la Dirección de Notificadores</h1> 
        <div class="flex-grow-1"><h4><i class="fas fa-info-circle"></i>&nbsp;&nbsp;&nbsp;Ingrese la informacion requerida para buscar y filtrar las cedulas</h4></div> COMENTARIO FIN
        <h1 style="margin-bottom: 0px;">CONSULTA PARA LA DIRECCIÓN DE NOTIFICADORES</h1>
        COMENTARIO<h3 style="margin-top: 0px;">Búsqueda de cédulas</h3>
      </div>
      <div id="encabezado-contenedor-contenido" class="form-inline mt-3">
        <div class="flex-grow-1 pl-3"><h4>Búsqueda y consulta de información</h4></div>
      </div>
      <div id="ContenidoConsultaDireccion_div" class="contenedor-informacion container-fluid">
        <div id="contenedor-filtos-consulta" class="row">
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 pl-3 pt-4">
            <div class="contenedor-color-negro">
               <FiltrosDeBusqueda                 
                :elementosAOmitir="elementosAOmitir"
                :mostrar="true"
                :ocultarParaDireccion="false"
                :posicionHorizontal="true"
                :conSwitchHabilitacion="true" 
                :catalogos="catalogos" 
                :ejecutaLaFuncion="evtBuscarCedulas" 
                :filtrosEstablecidos="filtrosEstablecidos" 
                :tituloDeBusqueda="'Paso 1: Busca las cédulas'"
                :esJuzgadoMixto="usuarioEsDeJuzgadoMixto"
                :todasJurisdicciones="true"
                v-on:cambiaInfoTodasJurisdicciones="evtcambiaInfoTodasJurisdicciones"
                v-on:cambioTipoDeCedula="evtCambioTipoCedula"
                v-on:cambioTipoNotificador="evtCambioTipoNotificador"
                v-on:AccionEnSwitchDeFiltros="evtAccionEnSwitchDeFiltros"
                :ref="REF_FB"></FiltrosDeBusqueda> 
            </div>
          </div>

          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 pl-3 pt-4">
              <div v-show="!cargandoCedulas && cedulasBD.length > 0" id="PanelDeAudienciasPendientesPendientes_table">
                <div style="background-color:black; padding: 8px;">
                  <div class="d-flex justify-content-center">
                    <i class="fas fa-clipboard-list mr-sm-2" style="font-size: 25px;"></i>
                    <div class="align-content-center">
                      <h5>Listado de cédulas encontradas</h5>
                    </div>
                  </div>
                </div>
                <div class="contenedor-color-negro mb-4" style="padding: 1em 0.7em 1em 0.7em;">
                  <div class="container-fluid">
                    COMENTARIO INICIO 
                      <div class="f-item align-self-end form-group">
                        <button type="button" id="btn-limpiar-filtro" @click="evtResetearFiltros" class="btn-sm btn-primary"><i class="fas fa-undo"></i></button>
                      </div>
                    </div> COMENTARIO FIN
                    SECCION ACCIONES
                    <div class="row seccion-acciones" v-if="(tablaCedulas.cedulasParaEnviarJuzgado.filter(c => c.enviar).length > 0 || tablaCedulasSolicitud.cedulas.length > 0) || (parametrosReporteCedulasPendientes.notificadorId == 29)">
                      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 pr-3 pt-4">
                        <button v-if="tablaCedulas.cedulasParaEnviarJuzgado.filter(c => c.enviar).length > 0" @click="evtAgregarCedulasASolicitud" type="button" class="btn btn-light texto-ajustable-btn mr-xs-2 mr-sm-2 mr-md-2 mr-lg-2"><i class="fas fa-plus-circle"></i>&nbsp;&nbsp;Agregar cédulas a lista de envío</button>
                        <button v-if="tablaCedulasSolicitud.cedulas.length > 0" @click="evtMostrarConfirmacionEnviarAJuzgado" type="button" class="btn btn-light texto-ajustable-btn"><i class="fas fa-paper-plane"></i>&nbsp;&nbsp;Enviar a juzgado</button>
                        <button v-if="cedulaSeleccionadaConResultado" @click="mostarModalCambioFechaResultado" type="button" class="btn btn-light texto-ajustable-btn mr-2"><i class="fas fa-exchange-alt"></i>&nbsp;&nbsp;Cambiar fecha de resultado</button>
                        <button v-if="tablaCedulas.cedulasParaEnviarJuzgado.filter(c => c.enviar).length > 0" @click="accionEnModal({ modal: 'modal-confirmacion-cancelacion-cedulas', mostrar: 'show' })" type="button" class="btn btn-danger texto-ajustable-btn"><i class="fas fa-window-close"></i>&nbsp;&nbsp;Cancelar cédulas</button>
                        <button v-if="parametrosReporteCedulasPendientes.notificadorId == 29" type="button" @click="accionEnModal({ modal: 'creacion-reporte-cedulas-pendientes-notificador', mostrar: 'show' })" class="btn btn-light texto-ajustable-btn mr-xs-2 mr-sm-2 mr-md-2 mr-lg-2"><i class="fas fa-file-pdf"></i>&nbsp;&nbsp;Reporte de cédulas pendientes</button>
                        <hr style="height:1.5px;border:none;color:#FFF;background-color:rgb(27, 27, 27); margin-top:9px; margin-bottom:2em;"/>
                      </div>
                    </div>
                    SECCION ACCIONES NOTIFICADOR
                    <div class="row seccion-acciones" v-if="esUsuarioNotificador">
                      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 pr-3 pt-4">
                        <button type="button" @click="accionEnModal({ modal: 'creacion-reporte-cedulas-pendientes-notificador', mostrar: 'show' })" class="btn btn-light texto-ajustable-btn mr-xs-2 mr-sm-2 mr-md-2 mr-lg-2"><i class="fas fa-file-pdf"></i>&nbsp;&nbsp;Reporte de cédulas pendientes</button>
                        <hr style="height:1.5px;border:none;color:#FFF;background-color:rgb(27, 27, 27); margin-top:9px; margin-bottom:2em;"/>
                      </div>
                    </div>
                    FIN SECCION ACCIONES NOTIFICADOR
                    <div id="filtros-memoria-cedulas-vcdd" class="form-inline mb-3 justify-content-end">
                      <div id="filtros-input-cedulas-memoria" class="f-item form-group mr-sm-2">
                        <h6 for="f-busqueda" class="mr-sm-2">Buscar:</h6>
                        <input v-model="f_busqueda" type="text" id="f-busqueda" placeholder="Buscar en todas las columnas" class="form-control" style="width: 300px;"/>
                      </div>
                      <div v-if="!this.infoTodasJurisdicciones" id="filtros-nivel-urgencia" class="f-item form-group mr-sm-2">
                        <select v-model="f_nivelUrgencia" @change="evtCambioTipoPrioridad($event)" class="form-control">
                          <option :value="-1">Prioridad</option>
                          <option :value="enumeraciones.sinoj.estadosNivelDeUrgencia.Rojo">Alta</option>
                          <option :value="enumeraciones.sinoj.estadosNivelDeUrgencia.Amarillo">Media</option>
                          <option :value="enumeraciones.sinoj.estadosNivelDeUrgencia.Verde">Baja</option>
                        </select> 
                      </div>
                      <div class="f-item form-group">
                        <button type="button" id="btn-limpiar-filtro" @click="evtResetearFiltros" class="btn-sm btn-primary"><i class="fas fa-undo"></i></button>
                      </div>
                    </div>
                    COMENTARIO <hr style="height:2px;border:none;color:#FFF;background-color:#fff; margin-top:1px;"/>
                     <TablaGenericaCedulas class="table-responsive"
                      :idDelInput="idTabla" 
                      :encabezadosColumnas="encabezadosColumnas" 
                      :accionesEnTabla="tablaAcciones" 
                      :listaDeCedulas="cedulasTablaConFiltros" 
                      v-on:accionFuncionDetalles="evtDetallesCedula"
                      v-on:elementosSeleccionados="evtObtenerCedulasSeleccionadas"
                      v-on:accionCambiarArea="evtCambiarArea"
                      :ref="REF_T_CEDULAS"
                      :conResponsive="true"
                      :key="'K'+ idTabla + tablaCedulas.contRender"></TablaGenericaCedulas> 

                     COMENTARIO - INICIO  <div class="row">
                        <div v-if="tablaCedulas.cedulasParaEnviarJuzgado.filter(c => c.enviar).length > 0 || tablaCedulasSolicitud.cedulas.length > 0" class="col-xs-12 col-sm-12 col-md-12 col-lg-12 pr-3 pt-4">
                            <button v-if="tablaCedulas.cedulasParaEnviarJuzgado.filter(c => c.enviar).length > 0" @click="evtAgregarCedulasASolicitud" type="button" class="btn btn-light texto-ajustable-btn mr-xs-2 mr-sm-2 mr-md-2 mr-lg-2"><i class="fas fa-plus-circle"></i>&nbsp;&nbsp;Agregar cédulas a lista de envío</button>
                            <button v-if="tablaCedulasSolicitud.cedulas.length > 0" @click="evtMostrarConfirmacionEnviarAJuzgado" type="button" class="btn btn-light texto-ajustable-btn"><i class="fas fa-paper-plane"></i>&nbsp;&nbsp;Enviar a juzgado</button>
                            <button v-if="cedulaSeleccionadaConResultado" @click="mostarModalCambioFechaResultado" type="button" class="btn btn-light texto-ajustable-btn"><i class="fas fa-exchange-alt"></i>&nbsp;&nbsp;Cambiar fecha de resultado</button>
                        </div>
                      </div> COMENTARIO - FIN
                  </div>
                </div>
              </div>
            <div v-show="cargandoCedulas" class="contenedor-cargando" style="height: 300px ;">
              <div class="text-center">
                  <i class="fas fa-spinner fa-spin fa-5x"></i>
                  <h4 class="mt-4">Cargando cédulas</h4>
              </div>
            </div>
            <div v-show="!cargandoCedulas && cedulasBD.length < 1">
                 SECCION ACCIONES NOTIFICADOR 
                <div class="row seccion-acciones mb-3" v-if="esUsuarioNotificador">
                  <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 pr-3 pt-4">
                    <button type="button" @click="accionEnModal({ modal: 'creacion-reporte-cedulas-pendientes-notificador', mostrar: 'show' })" class="btn btn-light texto-ajustable-btn mr-xs-2 mr-sm-2 mr-md-2 mr-lg-2"><i class="fas fa-file-pdf"></i>&nbsp;&nbsp;Reporte de cédulas pendientes</button>
                  </div>
                </div>
                 FIN SECCION ACCIONES NOTIFICADOR 
                <div class="contenedor-aviso-sin-resultados" style="height: 150px ;">
                  <div class="text-center">
                      <i class="fas fa-folder-open" style="font-size: 3em;"></i>
                      <h6 style="margin-top:0.5em;">No se encontraron cédulas</h6>
                  </div>
                </div>
            </div>
          </div>
        </div>
      </div> -->

      <!-- NUEVO LAYOUT -->
      <div id="encabezados-tp">
          <h1>CONSULTA PARA LA DIRECCIÓN DE NOTIFICADORES</h1>
          <h3>Busca y consulta toda información referente a las cédulas de notificación</h3>
          <div class="hr-titulo"></div>
      </div>
      <div class="row" style="margin-top: 3em;"> 
         <!-- SECCION PARA LOS FILTROS DE BUSQUEDA -->
         <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 pr-2 pb-4">
           <div class="card">
             <div class="card-header">
               <div class="form-inline" style="gap:1em !important;">
                 <h5><strong>Filtros de busqueda</strong></h5>
                 <strong>
                   <i :class="[(!mostrarInstruccionesFB) ? 'fas fa-chevron-down' : 'fas fa-chevron-up']" 
                       style="cursor: pointer; font-size: 1em;" 
                       @click="mostrarInstruccionesFB = !mostrarInstruccionesFB"
                       v-tooltip:right="(mostrarInstruccionesFB) ? 'Ocultar instrucciones' : 'Mostrar instrucciones'"></i>
                 </strong>
               </div>
               <div v-if="mostrarInstruccionesFB" class="alert alert-dark" role="alert">
                <h6 class="alert-heading"><strong><i class="fas fa-info-circle"></i>&nbsp;&nbsp;Nota: Ninguno de los filtros es obligatorio</strong></h6>
                <hr style="margin-top: 0;">
                <p>
                  <strong>[1].-&nbsp;Rango de fechas:</strong> El rango de fechas sera aplicado a las diferentes fechas segun el valor del filtro <strong>Tipo de estatus</strong>.<br>
                  <strong>[2].-&nbsp;Habilitar filtros:</strong> Para habilitar o deshabilitar los filtros se debera dar click en alguna de las las tres opciones de la parte superior segun los tipos de filtros que desean habilitar o deshabilitar.<br>
                  <strong>[3].-&nbsp;Filtro [Buscar en todas las Cédulas]:</strong> Si en este filtro esta habilitada la opción <strong>SI</strong>, en todas las busquedas incluira cedulas que tengan resultado y hayan sido enviadas al juzgado de origen. <br>
                  <strong>[3].-&nbsp;Filtro [Información de todas las Jurisdicciones:]:</strong> Si en este filtro esta habilitada la opción <strong>SI</strong>, en todas las busquedas incluira cedulas que tengan una jurisdiccion distinta a la dirección de notificadores. <br>
                </p>
               </div>
             </div>
             <div class="card-body">
               <FiltrosDeBusqueda    
                :elementosAConservar="elementosAConservar"             
                :elementosAOmitir="elementosAOmitir"
                :mostrar="true"
                :ocultarParaDireccion="false"
                :posicionHorizontal="true"
                :conSwitchHabilitacion="true" 
                :catalogos="catalogos" 
                :ejecutaLaFuncion="evtBuscarCedulas" 
                :filtrosEstablecidos="filtrosEstablecidos" 
                :tituloDeBusqueda="''"
                :esJuzgadoMixto="usuarioEsDeJuzgadoMixto"
                :todasJurisdicciones="true"
                v-on:cambiaInfoTodasJurisdicciones="evtcambiaInfoTodasJurisdicciones"
                v-on:cambioTipoDeCedula="evtCambioTipoCedula"
                v-on:cambioTipoNotificador="evtCambioTipoNotificador"
                v-on:AccionEnSwitchDeFiltros="evtAccionEnSwitchDeFiltros"
                :ref="REF_FB"></FiltrosDeBusqueda>
             </div>
           </div>
         </div>
         <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 pr-2 pt-4">
           <div class="card">
             <div class="card-header">
               <div class="d-flex align-items-center justify-content-between flex-wrap">
                  <h5><strong>Cédulas encontradas&nbsp;&nbsp;&nbsp;[ {{ this.cedulasBD.length }} ]</strong></h5>
                  <!-- ACCIONES DE BUSQUEDA -->
                  <div id="filtros-memoria-cedulas-vcdd" class="form-inline flex-wrap" style="gap: 0.5em !important;">
                    <div id="filtros-input-cedulas-memoria" class="f-item form-group mr-sm-2">
                      <input v-model="f_busqueda" type="text" id="f-busqueda" placeholder="Buscar en todas las columnas" class="form-control" style="width: 300px;"/>
                    </div>
                    <div v-if="!this.infoTodasJurisdicciones" id="filtros-nivel-urgencia" class="f-item form-group">
                      <select v-model="f_nivelUrgencia" @change="evtCambioTipoPrioridad($event)" class="form-control">
                        <option :value="-1">Prioridad</option>
                        <option :value="enumeraciones.sinoj.estadosNivelDeUrgencia.Rojo">Alta</option>
                        <option :value="enumeraciones.sinoj.estadosNivelDeUrgencia.Amarillo">Media</option>
                        <option :value="enumeraciones.sinoj.estadosNivelDeUrgencia.Verde">Baja</option>
                      </select> 
                    </div>
                    <div class="f-item form-group">
                      <button type="button" id="btn-limpiar-filtro" @click="evtResetearFiltros" class="btn-sm btn-primary"><i class="fas fa-undo"></i></button>
                    </div>
                  </div>
               </div>
             </div>
             <div class="card-body" style="padding: 1.5rem 2rem 1.5rem 2rem !important;">

              <div v-show="!cargandoCedulas && cedulasBD.length > 0">
                <div class="d-flex mb-1 mt-1 justify-content-between flex-wrap"
                     v-if="(tablaCedulas.cedulasParaEnviarJuzgado.filter(c => c.enviar).length > 0 || tablaCedulasSolicitud.cedulas.length > 0) || (parametrosReporteCedulasPendientes.notificadorId == 29) || esUsuarioNotificador">
                  <div class="d-flex" style="gap: 1.5em !important;">
                    <!-- SECCION ACCIONES -->
                    <div class="seccion-acciones" v-if="(tablaCedulas.cedulasParaEnviarJuzgado.filter(c => c.enviar).length > 0 || tablaCedulasSolicitud.cedulas.length > 0) || (parametrosReporteCedulasPendientes.notificadorId == 29)">
                      <div class="d-flex flex-wrap" style="gap: 0.3em !important;">
                        <button v-if="tablaCedulas.cedulasParaEnviarJuzgado.filter(c => c.enviar).length > 0" @click="evtAgregarCedulasASolicitud" type="button" class="btn btn-light"><i class="fas fa-plus-circle"></i><span>&nbsp;&nbsp;Agregar cédulas a lista de envío</span></button>
                        <button v-if="tablaCedulasSolicitud.cedulas.length > 0" @click="evtMostrarConfirmacionEnviarAJuzgado" type="button" class="btn btn-light"><i class="fas fa-paper-plane"></i><span>&nbsp;&nbsp;Enviar a juzgado</span></button>
                        <button v-if="cedulaSeleccionadaConResultado" @click="mostarModalCambioFechaResultado" type="button" class="btn btn-light"><i class="fas fa-exchange-alt"></i><span>&nbsp;&nbsp;Cambiar fecha de resultado</span></button>
                        <button v-if="tablaCedulas.cedulasParaEnviarJuzgado.filter(c => c.enviar).length > 0" @click="accionEnModal({ modal: 'modal-confirmacion-cancelacion-cedulas', mostrar: 'show' })" type="button" class="btn btn-danger"><i class="fas fa-window-close"></i><span>&nbsp;&nbsp;Cancelar cédulas</span></button>
                        <button v-if="parametrosReporteCedulasPendientes.notificadorId == 29" type="button" @click="accionEnModal({ modal: 'creacion-reporte-cedulas-pendientes-notificador', mostrar: 'show' })" class="btn btn-light"><i class="fas fa-file-pdf"></i><span>&nbsp;&nbsp;Reporte de cédulas pendientes</span></button>
                      </div>
                    </div>
                    <!-- SECCION ACCIONES NOTIFICADOR -->
                    <div class="seccion-acciones" v-if="esUsuarioNotificador">
                      <div class="d-flex flex-wrap" style="gap: 1.5em !important;">
                        <button type="button" @click="accionEnModal({ modal: 'creacion-reporte-cedulas-pendientes-notificador', mostrar: 'show' })" class="btn btn-light"><i class="fas fa-file-pdf"></i><span>&nbsp;&nbsp;Reporte de cédulas pendientes</span></button>
                      </div>
                    </div>
                  </div>
                  <div v-if="tablaCedulas.cedulasParaEnviarJuzgado.filter(c => c.enviar).length > 0">
                    <h6><strong><i class="fas fa-check-square"></i>&nbsp;&nbsp;Cédulas: {{ tablaCedulas.cedulasParaEnviarJuzgado.filter(c => c.enviar).length }}</strong></h6>
                  </div>
                </div>
                <div v-if="cedulasTabla && !this.infoTodasJurisdicciones" class="form-inline flex-wrap mb-2" style="gap: 0.5em !important;">                  
                  <button type="button" class="btn btn-primary texto-ajustable" @click="downloadExportSearch()"><i class="fas fa-file-export"></i>&nbsp;&nbsp;Exportar Búsqueda (Excel/Pdf)</button>
                </div>
                <TablaGenericaCedulas class="table-responsive"
                  :idDelInput="idTabla" 
                  :encabezadosColumnas="encabezadosColumnas" 
                  :accionesEnTabla="tablaAcciones" 
                  :listaDeCedulas="cedulasTablaConFiltros" 
                  v-on:accionFuncionDetalles="evtDetallesCedula"
                  v-on:elementosSeleccionados="evtObtenerCedulasSeleccionadas"
                  v-on:accionCambiarArea="evtCambiarArea"
                  :ref="REF_T_CEDULAS"
                  :conResponsive="true"
                  :key="'K'+ idTabla + tablaCedulas.contRender"></TablaGenericaCedulas>
              </div>
            <div v-show="cargandoCedulas" class="contenedor-cargando" style="height: 300px ;">
              <div class="text-center">
                  <i class="fas fa-spinner fa-spin fa-5x"></i>
                  <h4 class="mt-4">Cargando cédulas</h4>
              </div>
            </div>
            <div v-show="!cargandoCedulas && cedulasBD.length < 1">
                <!-- SECCION ACCIONES NOTIFICADOR -->
                <div class="row seccion-acciones mb-3" v-if="esUsuarioNotificador">
                  <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 pr-3 pt-4">
                    <button type="button" @click="accionEnModal({ modal: 'creacion-reporte-cedulas-pendientes-notificador', mostrar: 'show' })" class="btn btn-light texto-ajustable-btn mr-xs-2 mr-sm-2 mr-md-2 mr-lg-2"><i class="fas fa-file-pdf"></i>&nbsp;&nbsp;Reporte de cédulas pendientes</button>
                  </div>
                </div>
                <!-- FIN SECCION ACCIONES NOTIFICADOR -->
                <div class="contenedor-aviso-sin-resultados" style="height: 150px ;">
                  <div class="text-center">
                      <i class="fas fa-folder-open" style="font-size: 3em;"></i>
                      <h6 style="margin-top:0.5em;">No se encontraron cédulas</h6>
                  </div>
                </div>
            </div>

             </div>
           </div>
         </div>
      </div>

    </div>
    <!-- MODAL SOLICIUD DE CEDULAS PARA REPORTE -->
      <div class="modal align-middle" tabindex="-1" data-backdrop="static" data-keyboard="false"  id="solicitud-cedulas-envio-juzgado">
          <div class="modal-dialog modal-lg modal-dialog-centered">
              <div class="modal-content">
                  <div class="modal-header">
                      <h5 class="modal-title">Cédulas seleccionadas para envio a juzgado</h5>
                      <button id="btn-cerrar-solicitud-cedulas-envio-juzgado" class="close" data-dismiss="modal"><i class="fas fa-times-circle"></i></button>
                  </div>
                  <div class="modal-body pl-4 pr-4">
                      <div id="contenedor-error-formulario" v-if="tablaCedulasSolicitud.mostrarErrorFomulario && fechaDeEnvioJuzgado < moment().format('YYYY-MM-DD')">
                          <h6><i class="fas fa-exclamation-triangle text-danger"></i>&nbsp;Error en Formulario</h6>
                          <span style="text-align: justify; display:block;">Fecha de envio incorrecta,No se puede enviar una cedula al juzgado con una fecha menor al dia de hoy</span>
                      </div>
                      <h6>*Revisa la informacion antes de enviar a juzgado&nbsp;&nbsp;
                          <i id="accion-eliminar-solicitudes" @click="evtLimpiarSolicitudes" class="fas fa-trash"></i></h6>
                      <TablaGenericaCedulas class="table-responsive mt-1"
                          :idDelInput="tablaCedulasSolicitud.ID_TABLA_CEDULAS_ENCONTRADAS"
                          :encabezadosColumnas="tablaCedulasSolicitud.encabezadosColumnas"
                          :accionesEnTabla="tablaCedulasSolicitud.tablaAcciones"
                          :listaDeCedulas="tablaCedulasSolicitud.cedulas"
                          :conResponsive="true"
                          v-on:accionFuncionEliminar="evtRemoverCedulaDeSolicitud"
                          :ref="tablaCedulasSolicitud.REF_TABLA_CEDULAS"
                          :key="'KTablaCedulasEnviadasAJuzgadosolicitud' + tablaCedulasSolicitud.contRender"></TablaGenericaCedulas>
                      <div v-if="tablaCedulasSolicitud.cedulas.length > 0" class="d-flex justify-content-between mt-4">
                        <div class="form-inline"> 
                          <h6 class="mr-2">Fecha de envio: </h6>
                          <input type="date" v-model="fechaDeEnvioJuzgado" class="form-control" />
                        </div>
                        <div>
                          <button @click="iniciarProcesoDeEnvioAJuzgado" type="button" class="btn btn-light texto-ajustable-btn"><i class="fas fa-paper-plane"></i>&nbsp;&nbsp;Enviar</button>
                        </div>
                      </div>
                  </div>             
              </div>
          </div>
      </div>
      <!-- MODAL CON VISUALIZADOR DE REPORTE -->
      <div class="modal align-middle" tabindex="-1" data-backdrop="static" data-keyboard="false"  id="visualizador-reporte-consultaDireccion">
          <div class="modal-dialog modal-lg modal-dialog-centered">
              <div class="modal-content">
                  <div class="modal-header">
                      <h5 class="modal-title">Reporte cédulas enviadas</h5>
                      <button id="btn-cerrar-visualizador-reporte-consultaDireccion" class="close" data-dismiss="modal"><i class="fas fa-times-circle"></i></button>
                  </div>
                  <div class="modal-body pl-4 pr-4">
                      <PDFDocument 
                          :url="visualizadorDelReporte.url" 
                          :EsBase64="EsBase64"
                          :ArchivoAConvertir="visualizadorDelReporte.archivoDeReporte"
                          :height="visualizadorDelReporte.height"
                          :key="'VDRCEJZDDIR' + visualizadorDelReporte.contRender" />
                  </div>             
              </div>
          </div>
      </div>
      <!-- Modal para Cambiar el área encargada -->
      <div class="modal align-middle" tabindex="-1" data-backdrop="static" data-keyboard="false" id="cambiarAreaEncargada_modal">
          <div class="modal-dialog modal-lg modal-dialog-centered">
              <div class="modal-content">
                  <div class="modal-header">
                      <h5 class="modal-title">Cambio de área encargada</h5>
                      <button id="btn-cerrar-visualizador-reporte-consultaDireccion" class="close" data-dismiss="modal"><i class="fas fa-times-circle"></i></button>
                  </div>
                  <div class="modal-body pl-4 pr-4">
                      <p>Favor de seleccionar el área que llevará a cabo la notificación</p>
                      <C003Jurisdicciones v-on:valorParaElPadre="cambioDeJurisdiccion" :prefijo="enumeraciones.etiquetasDeHTML.Select" :tipo="enumeraciones.tiposDeSelect.Seleccione" :idDelInput="'creacionDeCedula_Jurisdiccion'" :parametros="parametros_Jurisdicciones.parametros" :valorDefinido="parametros_Jurisdicciones.jurisdiccionId" :key="parametros_Jurisdicciones.key"></C003Jurisdicciones>
                  </div>   
                  <div class="modal-footer">
                    <button class="btn btn-light texto-ajustable-btn" @click="guardarNuevaAreaEncargada()">Guardar</button>
                  </div>          
              </div>
          </div>
      </div>
      <!-- MODAL SELECCION DE CEDULAS PARA REPORTE -->
      <div class="modal align-middle" tabindex="-1" data-backdrop="static" data-keyboard="false"  id="modal-cambio-fecha-resultado">
          <div class="modal-dialog modal-lg modal-dialog-centered">
              <div class="modal-content">
                  <div class="modal-header">
                      <h5 class="modal-title">Cambio de fecha a resultado/s</h5>
                      <button id="btn-cerrar-modal-cambio-fecha-resultado" class="close" data-dismiss="modal"><i class="fas fa-times-circle"></i></button>
                  </div>
                  <div class="modal-body pl-4 pr-4">
                      <div id="contenedor-inf-reporte-general" class="alert alert-secondary text-justify" role="alert">
                          <h5><i class="fas fa-info-circle"></i>&nbsp;&nbsp;Nota</h5>
                          <h6>Solo se modificará la fecha del resultado de las cédulas que cuenten con el registro previo de un resultado.</h6>
                      </div>
                      <div class="form-group mt-2 mb-2">
                          <h6>Fecha de resultado</h6>
                          <input v-model="resultados.fecha" type="date" class="form-control flex-grow-1" />
                      </div>
                      <!-- <i v-if="resultados.errorEnFechas" class="text-danger">(*) Las fecha ingresada no puede estar vacia.</i> -->
                  </div>      
                  <div class="modal-footer">
                      <div class="d-flex justify-content-end">
                          <button type="button" @click="iniciarProcesoCambioFechaDeResultado" class="btn btn-light"><i class="fas fa-file-alt"></i>&nbsp;&nbsp;Guardar</button>
                      </div>
                  </div>       
              </div>
          </div>
      </div>
      <!-- MODAL CONFIRMACION CANCELACION DE CEDULAS-->
      <div class="modal align-middle" tabindex="-1" data-backdrop="static" data-keyboard="false"  id="modal-confirmacion-cancelacion-cedulas">
          <div class="modal-dialog modal-lg">
              <div class="modal-content">
                  <div class="modal-header">
                      <h5 class="modal-title">Mensaje del sistema</h5>
                  </div>
                  <div class="modal-body pl-4 pr-4">
                      <div class="form-group">
                          <div id="info-modal" class="alert alert-secondary text-jsutify" role="alert">
                            <h4><i class="fas fa-info-circle"></i>&nbsp;&nbsp;Aviso</h4>
                            <hr style="height:1px;border:none;color:#FFF;background-color:rgb(65, 65, 65); margin-top:9px; margin-bottom:1em;"/>
                            <h6>Las cédulas seleccionadas se eliminarán del sistemas y no serán accesibles para el área encargada de realizar la notificación y el juzgado de origen.</h6>
                          </div>
                      </div>
                      <div class="modal-footer">
                          <div class="form-inline justify-content-end">
                            <h6 class="mr-3">¿Deseas continuar?</h6>
                            <button type="button" class="btn btn-success mr-2" @click="evtIniciarProcesoParaCancelacionDeCedulas"><i class="fas fa-check"></i>&nbsp;&nbsp;Si</button>
                            <button type="button" class="btn btn-danger" @click="accionEnModal({ modal: 'modal-confirmacion-cancelacion-cedulas', mostrar: 'hide' })"><i class="fas fa-times"></i>&nbsp;&nbsp;No</button>
                          </div>
                      </div>
                  </div>             
              </div>
          </div>
      </div>
      <!-- MODAL REPORTE CEDULAS PENDIENTES NOTIFICADOR -->
      <div class="modal align-middle" tabindex="-1" data-backdrop="static" data-keyboard="false"  id="creacion-reporte-cedulas-pendientes-notificador">
          <div class="modal-dialog modal-lg modal-dialog-centered">
              <div class="modal-content">
                  <div class="modal-header">
                      <h5 class="modal-title">Reporte cédulas pendientes de notificador</h5>
                      <button id="btn-cerrar-creacion-reporte-cedulas-pendientes-notificador" class="close" data-dismiss="modal"><i class="fas fa-times-circle"></i></button>
                  </div>
                  <div class="modal-body pl-4 pr-4">
                      <div id="contenedor-inf-reporte-general" class="alert alert-secondary text-justify" role="alert">
                          <h5><i class="fas fa-info-circle"></i>&nbsp;&nbsp;Nota</h5>
                          <h6>Solo se generara el reporte de notificadores que tengan cédulas asignadas con la fecha ingresada en el campo <strong>[Periodo de asignación]</strong>, El reporte solo incluye cédulas pendientes.</h6>
                      </div>
                      <h6>Periodo de asignación</h6>
                      <div class="d-flex mt-2 mb-2">
                          <div class="form-group pl-0 pr-0 col-5">
                              <input v-model="parametrosReporteCedulasPendientes.fechaInicial" type="date" class="form-control flex-grow-1" />
                          </div>
                          <div class="col-2 d-flex justify-content-center">
                              <h6>a</h6>
                          </div>
                          <div class="form-group pl-0 pr-0 col-5">
                              <input v-model="parametrosReporteCedulasPendientes.fechaFinal" type="date" class="form-control flex-grow-1" />
                          </div>
                      </div>
                      <i v-if="parametrosReporteCedulasPendientes.errorEnFechas" class="text-danger">(*) Las fechas no pueden estar vacias, tener la fecha inicial mayor a la fecha final y la fecha final menor a la fecha inicial.</i>
                  </div>      
                  <div class="modal-footer">
                      <div class="d-flex justify-content-end">
                          <button  type="button" @click="iniciarProcesoCreacionDeReporteCedulasPendientes" class="btn btn-info"><i class="fas fa-file-alt"></i>&nbsp;&nbsp;Generar</button>
                      </div>
                  </div>       
              </div>
          </div>
      </div>
      <!-- MODAL CON VISUALIZADOR DE REPORTE -->
      <div class="modal align-middle" tabindex="-1" data-backdrop="static" data-keyboard="false"  id="visualizador-reporte-notificador-pendientes-VCDDIR">
          <div class="modal-dialog modal-lg modal-dialog-centered">
              <div class="modal-content">
                  <div class="modal-header">
                      <h5 class="modal-title">Reporte generado</h5>
                      <button id="btn-cerrar-visualizador-reporte-notificador-pendientes-VCDDIR" class="close" data-dismiss="modal"><i class="fas fa-times-circle"></i></button>
                  </div>
                  <div class="modal-body pl-4 pr-4">
                      <PDFDocument 
                          :url="reporte.visualizador.url" 
                          :EsBase64="EsBase64"
                          :ArchivoAConvertir="reporte.visualizador.archivoDeReporte"
                          :height="reporte.visualizador.height"
                          :key="'VCDDIR' + reporte.visualizador.contRender" />
                  </div>           
              </div>
          </div>
      </div>
  </div>
</template>
<script>
  import enumeraciones from '@/../static/js/enumeraciones'
  import comun from "@/../static/js/comun"
  import sistemas from '@/../static/js/sistemas'
  import api from '@/../static/js/api'
  import axios from 'axios'
  import router from '@/router/index'
  import VueMask from 'v-mask'
  import { mapActions } from 'vuex'
  import moment from 'moment'
  import cedulas from '../../../../../static/js/api/SINOJ/sistema/Cedulas/Cedulas'
  import PDFDocument from '@/../src/components/Comunes/PDFDocument'
  import catalogos from '@/../static/js/catalogos'
  import { tooltipF } from '@/../static/js/tooltip/ToolTipDirective.js'
  import { areasAFiltrarParaDireccion } from "../../Comun/Funciones/validaciones.js"
  import { servicioRestPost } from '../../../Audiencias/Programacion/servicios/ServiciosHttp.js'

  Vue.use(VueMask);
  export default {
    directives: {
      tooltipF
    },
    components: {
      PDFDocument: PDFDocument,
      C003Jurisdicciones: catalogos.SINOJ.C003Jurisdicciones, 
      FiltrosDeBusqueda: sistemas.SINOJ.FiltrosDeBusqueda,
      TablaGenericaCedulas: sistemas.SINOJ.CTablaGenericaCedulas
    },
    data() {
      return {
        obtenerCedulas: false,
        EsBase64:{},
        areasAFiltrarParaDireccion,
        elementosAConservar: {},
        elementosAOmitir: {
          areas: [26]
        },
        infoTodasJurisdicciones: false,
        enumeraciones,
        moment,
        catalogos: [
          /* { catalogoId: enumeraciones.sinoj.catalogos.DireccionesDeNotificadores, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione, idDelInput: 'filtroDeBusqueda_AreaResponsable_ConsultaDireccion' }, */
          { catalogoId: 'filtroNumeroFolio', idDelInput: 'FNumFolioVCDDIR'},
          { catalogoId: enumeraciones.catalogos.PartidosJudiciales, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione, idDelInput: 'filtroDeBusqueda_PartidoJudicial_ConsultaDireccion' },
          { catalogoId: enumeraciones.catalogos.Materias, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione, idDelInput: 'filtroDeBusqueda_Materia_ConsultaDireccion' },
          { catalogoId: enumeraciones.catalogos.Juzgados, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione, idDelInput: 'filtroDeBusqueda_Area_ConsultaDireccion' },
          { catalogoId: enumeraciones.catalogos.TiposDeDocumentos, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione, idDelInput: 'filtroDeBusqueda_TipoDocumento_ConsultaDireccion' },
          { catalogoId: enumeraciones.catalogos.Consecutivo, idDelInput: 'filtroDeBusqueda_Consecutivo_ConsultaDireccion' },
          { catalogoId: enumeraciones.sinoj.catalogos.TiposDeCedula, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione, idDelInput: 'filtroDeBusqueda_TipoCedula_ConsultaDireccion' },
          { catalogoId: enumeraciones.sinoj.catalogos.Notificadores, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione, idDelInput: 'filtroDeBusqueda_Notificador_ConsultaDireccion' },
          { catalogoId: 'filtroPersona', etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione, idDelInput: 'filtroDeBusqueda_PersonaANotificar_ConsultaDireccion' },
          { catalogoId: enumeraciones.catalogos.FechaDeInicio },
          { catalogoId: enumeraciones.catalogos.FechaFinal },
          { catalogoId: enumeraciones.catalogos.NumeroExtra, idDelInput: 'f-nExtra-VCDDIR' },
          { catalogoId: 'estatusDeCedula', idDelInput: 'f-estatus-VCDDIR' },
          { catalogoId: 'conCedulasAnteriores', idDelInput: 'f-cedulasAteriores-VCDDIR' },
          { catalogoId: 'fechaAudiencia', idDelInput: 'f-fechaAudiencia-VCDDIR' }
        ],
        filtrosEstablecidos: {},
        idTabla: 'tCedulasVCD',
        encabezadosColumnas: ['', 'Folio','Juzgado','Consecutivo','Tipo de documento','Domicilio','Persona a notificar', 'Tipo de cédula','Estatus', 'Resultado','Fecha de envio a juzgado', ''],
        tablaAcciones: { motrarAcciones: true, check: true, eliminar: false, detalles: true, cambiarArea: true },
        listaDeCedulas: [
          { semaforo: `<i class="fa fa-circle text-danger"></i>`, Folio: 12321, juzgado: '1° Civil', tipoDeDocumento: 'Expediente Principal', consecutivo: '0001/2020', tipoDeCedula: '001', estatus: 'Realizada', resultado: 'Razonada' },
          { semaforo: `<i class="fa fa-circle text-success"></i>`, Folio: 12321, juzgado: '1° Civil', tipoDeDocumento: 'Expediente Principal', consecutivo: '0001/2020', tipoDeCedula: '001', estatus: 'Realizada', resultado: 'Razonada' },
          { semaforo: `<i class="fa fa-circle text-warning"></i>`, Folio: 12321, juzgado: '1° Civil', tipoDeDocumento: 'Expediente Principal', consecutivo: '0001/2020', tipoDeCedula: '001', estatus: 'Realizada', resultado: 'Razonada' },
          { semaforo: `<i class="fa fa-circle text-success"></i>`, Folio: 12321, juzgado: '1° Civil', tipoDeDocumento: 'Expediente Principal', consecutivo: '0001/2020', tipoDeCedula: '001', estatus: 'Realizada', resultado: 'Razonada' },
          { semaforo: `<i class="fa fa-circle text-success"></i>`, Folio: 12321, juzgado: '1° Civil', tipoDeDocumento: 'Expediente Principal', consecutivo: '0001/2020', tipoDeCedula: '001', estatus: 'Realizada', resultado: 'Razonada' },
        ],
        cargandoCedulas: false,
        f_busqueda : null,
        f_nivelUrgencia: -1,
        mesajeSinCedulas: 'No se ha realizado ninguna búsqueda, en el paso 1 presione el botón de Buscar.',
        cedulasBD: [],
        cedulasTabla: [],
        cedulasTablaConFiltros: [],
        REF_T_CEDULAS: 'REFtablaConsultasVCD',
        REF_FB: 'REFFiltrosBVCD',
        tipoCedulaId: -1,
        tipoNotificadorId: -1,
        contadorRenderFiltros: 0,
        FILTROS_CARGADOS_PREVIAMENTE: null,
        ATRIBUTO_FILTROS: 'filtrosPrevios',
        ATRIBUTO_CEDULA: 'cedulaSeleccionada',
        FILTROS_BUSQUEDA: null,
        FORMATO_FECHA: "DD/MM/YYYY",
        tablaCedulas: {
          contRender: 0,
          cedulasParaEnviarJuzgado: [],
          hayCedulasSeleccionadas: false
        },
        tablaCedulasSolicitud: {
            ID_TABLA_CEDULAS_ENCONTRADAS: 'tablaCEnvioCedulasJuzgadoSolicitud',
            REF_TABLA_CEDULAS: 'REFtablaCEnvioCedulasJuzgadoSolicitud',
            encabezadosColumnas: ['Folio','Juzgado','Consecutivo','Tipo de documento','Domicilio','Persona a notificar', 'Tipo de cédula','Estatus', 'Resultado','Fecha de envio a juzgado', ''],
            tablaAcciones: { motrarAcciones: true, check: false, eliminar: true, detalles: false, cambiarArea: true },
            cedulas: [],
            contRender: 0,
            mostrarErrorFomulario: false
        },
        fechaDeEnvioJuzgado: moment().format('YYYY-MM-DD'),
        esUsuarioNotificador: false,
        visualizadorDelReporte: {
            url: null,
            height: '500px',
            archivoDeReporte: null,
            contRender: 0
        },
        filtrosDeBusquedaSecciones: {
          expediente: true,
          cedula: true,
          fechas: true
        },
        cargoAreaDeUsuario: false,
        usuarioEsDeJuzgadoMixto: false,
        parametros_Jurisdicciones: {
            key: "",
            jurisdiccionId: -1,
            cedulaSeleccionada:{},
            parametros: {
                conAreasDeJurisdiccion: false
            }
        },
        resultados: {
          fecha: moment().format('YYYY-MM-DD'),
          errorEnFecha: false
        },
        parametrosReporteCedulasPendientes: {
            fechaInicial: moment().format('YYYY-MM-DD'),
            fechaFinal: moment().add(1, 'days').format('YYYY-MM-DD'),
            errorEnFechas: false,
            notificadorId: -1
        },
        reporte: {
            visualizador: {
                url: null,
                height: '500px',
                archivoDeReporte: null,
                contRender: 0
            }
        },
        mostrarInstruccionesFB: false
      }
    },
    methods: {
      downloadExportSearch: async function() {
        comun.SeEstaCargandoInformacion(true);
        try {                         
            let cedulasTablaFiltradas = [];
            Object.entries(this.cedulasTabla).forEach((c) => {
              let objCedula = {
                Folio: c[1].Folio,
                Juzgado: c[1].Juzgado,
                Consecutivo: c[1].Consecutivo,
                TipoDocumento: c[1].TipoDocumento,
                Domicilio: c[1].Domicilio,
                PersonaANotificar: c[1].PersonaANotificar,
                TipoCedula: c[1].TipoCedula.includes("AUDIENCIAS") || c[1].TipoCedula.includes("AUDIENCIA CONFESIONAL") ? (c[1].TipoCedula.replace('<br><strong>',' - ')).replace('</strong>','') : c[1].TipoCedula,
                Notificador: c[1].Notificador
              };
              cedulasTablaFiltradas.push(objCedula);
            });
            
            let encabezadosColumnasFiltrados = [];
            encabezadosColumnasFiltrados.push("Numero");
            Object.entries(this.encabezadosColumnas).forEach((e) => {
              if(e[1] == '')
                  return;
              if(e[1] == 'Estatus')
                  return;
              if(e[1] == 'Resultado')
                  return;
              if(e[1] == 'Fecha de envio a juzgado')
                  return;
              encabezadosColumnasFiltrados.push(e[1]);
            });
            
            let fechaInicialFormateada = this.$refs[this.REF_FB].fechaInicial.substring(8, 10) + "/" + this.$refs[this.REF_FB].fechaInicial.substring(5, 7) + "/" + this.$refs[this.REF_FB].fechaInicial.substring(0, 4);            
            let fechaFinalFormateada = this.$refs[this.REF_FB].fechaFinal.substring(8, 10) + "/" + this.$refs[this.REF_FB].fechaFinal.substring(5, 7) + "/" + this.$refs[this.REF_FB].fechaFinal.substring(0, 4);            

            const PARAMETROS_REPORTE = { 
                CedulasParaReporte: cedulasTablaFiltradas,
                EncabezadosColumnas: encabezadosColumnasFiltrados,
                FechaInicial: fechaInicialFormateada,
                FechaFinal: fechaFinalFormateada
            }           
            {
              const { CON_ERROR, RESPUESTA }  = await Promise.resolve(servicioRestPost({
                  servicioUrl: api.SINOJ.sistema.consultas.consultaDireccion.ObtenerReportesExportarBusquedaPDF,
                  peticionServicio: PARAMETROS_REPORTE,
                  headers: { TOKEN_AUTORIZACION:this.$store.state.Login_AutorizacionOriginal, HEADER_PARA_ENVIO_ARCHIVOS: false, HEADER_PARA_ARRAY_BUFFER: true }
              }));
              if(!CON_ERROR) {    
                  if(RESPUESTA.byteLength > 0) {
                      let blobFileReportPDF = new Blob([RESPUESTA], { type: 'application/pdf' });
                      let urlPDF = window.URL.createObjectURL(blobFileReportPDF);
                      let linkPDF = document.createElement("a");
                      linkPDF.download = 'ReporteExportarBusquedaPDF';
                      linkPDF.href = urlPDF;
                      linkPDF.click();
                  }
                  else {
                      comun.mensajeDeAlerta('Ocurrio un error al generar el reporte en pdf., vuelve intentarlo.');
                  }
              }
            }
            const { CON_ERROR, RESPUESTA }  = await Promise.resolve(servicioRestPost({
                servicioUrl: api.SINOJ.sistema.consultas.consultaDireccion.ObtenerReportesExportarBusquedaExcel,
                peticionServicio: PARAMETROS_REPORTE,
                headers: { TOKEN_AUTORIZACION:this.$store.state.Login_AutorizacionOriginal, HEADER_PARA_ENVIO_ARCHIVOS: false, HEADER_PARA_ARRAY_BUFFER: true }
            }));

            if(!CON_ERROR) {                
                if(RESPUESTA.byteLength > 0) {
                    let blocFileReportExcel = new Blob([RESPUESTA], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;' }); 
                    let urlExcel = window.URL.createObjectURL(blocFileReportExcel);
                    let linkExcel = document.createElement("a");
                    linkExcel.download = 'ReporteExportarBusquedaExcel';
                    linkExcel.href = urlExcel;
                    linkExcel.click();
                }
                else {
                    comun.mensajeDeAlerta('Ocurrio un error al generar el reporte en excel., vuelve intentarlo.');
                }
            }
           
        }
        catch(ex) {
            comun.mensajeDeAlerta('Ocurrio un error al generar el reporte, vuelve intentarlo.');
            console.error(ex);
        }
        comun.SeEstaCargandoInformacion(false);
      },
      iniciarProcesoCreacionDeReporteCedulasPendientes: async function() { 
          this.parametrosReporteCedulasPendientes.errorEnFechas = this.fechasDeReporteIncorrectas();
          if(!this.parametrosReporteCedulasPendientes.errorEnFechas) {
              this.accionEnModal({ modal: 'creacion-reporte-cedulas-pendientes-notificador', mostrar: 'hide' });
              const { fechaInicial, fechaFinal, notificadorId } = this.parametrosReporteCedulasPendientes;
              const PETICION_API = { NotificadorId: notificadorId, FechaInicial: fechaInicial, FechaFinal: fechaFinal, EsPrueba: false };
              let REPORTE_SIN_ERROR = await Promise.resolve(this.obtenerReporteCedulasPendientesNotifiadorBD({ peticion: PETICION_API }));
              if(REPORTE_SIN_ERROR) {
                  this.accionEnModal({ modal: 'visualizador-reporte-notificador-pendientes-VCDDIR', mostrar: 'show' });
                  this.reporte.visualizador.contRender ++;
              }
              else
                  comun.mensajeDeAlerta('No se encontró información con los parámetros ingresados.');
          }
      },
      obtenerReporteCedulasPendientesNotifiadorBD: async function({ peticion }) { 
            let seObtuvoReporte = false;
            try {
                const SERVIDOR = api.conexion;
                const METODO_API_OBTENER = api.SINOJ.sistema.reportes.reporteAsignacionesNotificadores.ObtenerReporteCedulasPendientesNotificador;
                let urlApi = SERVIDOR + METODO_API_OBTENER;
                let peticionArchivos = false;
                let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos,true);
                comun.SeEstaCargandoInformacion(true);
                const RESPUESTA_SOLICITUD = await axios.post(urlApi, peticion, headerPeticion);
                const DATOS = await RESPUESTA_SOLICITUD.data;
                if(DATOS.byteLength > 0) {
                    this.reporte.visualizador.archivoDeReporte = new File([DATOS], 'ReporteCedulasPendientesDeNotificador', { type: 'application/pdf' });
                    seObtuvoReporte = true;
                }
                comun.SeEstaCargandoInformacion(false);
            }
            catch(excepcion) {
                comun.SeEstaCargandoInformacion(false);
                console.log(excepcion);
                comun.mensajeDeAlerta(enumeraciones.error.E500, null, null);
            }
            return seObtuvoReporte;
        },
      fechasDeReporteIncorrectas: function() { 
          let esIncorrecto = (this.parametrosReporteCedulasPendientes.fechaInicial != null && this.parametrosReporteCedulasPendientes.fechaFinal != null) 
              ? (this.parametrosReporteCedulasPendientes.fechaInicial > this.parametrosReporteCedulasPendientes.fechaFinal || this.parametrosReporteCedulasPendientes.fechaFinal < this.parametrosReporteCedulasPendientes.fechaInicial)
                  ? true : false
              : true;
          return esIncorrecto;
      },
      accionEnModal: function({ modal, mostrar }) {
        $("#" + modal).modal(mostrar);
      },
      evtIniciarProcesoParaCancelacionDeCedulas: async function() {
        const CEDULAS_PARA_CANCELAR = this.tablaCedulas.cedulasParaEnviarJuzgado.filter(c => c.enviar).map(c => ({ CedulaId: c.folio, FechaDeRegistro: new Date() }));
        if(this.campoRequeridoEsValido(CEDULAS_PARA_CANCELAR)) {
           this.accionEnModal({ modal: 'modal-confirmacion-cancelacion-cedulas', mostrar: 'hide' })
           const PETICION_API = {
             Cedulas: CEDULAS_PARA_CANCELAR,
             EsPrueba: false
           };
           const { finalizoSinError, cedulasARemover } = await Promise.resolve(this.cancelarCedulasBD({ peticion: PETICION_API }));
           if(finalizoSinError) {
             // remueve las cedulas eliminadas de todas las lista de cedulas en memoria
             this.tablaCedulas.cedulasParaEnviarJuzgado = this.tablaCedulas.cedulasParaEnviarJuzgado.filter(c => !cedulasARemover.some(cr => cr.CedulaId == c.folio));
             this.tablaCedulasSolicitud.cedulas = this.tablaCedulasSolicitud.cedulas.filter(c => !cedulasARemover.some(cr => cr.CedulaId == c.Folio));
             this.cedulasTablaConFiltros = this.cedulasTablaConFiltros.filter(c => !cedulasARemover.some(cr => cr.CedulaId == c.Folio));
             this.cedulasBD = this.cedulasBD.filter(c => !cedulasARemover.some(cr => cr.CedulaId == c.CedulaId));
             this.cedulasTabla = this.cedulasTabla.filter(c => !cedulasARemover.some(cr => cr.CedulaId == c.Folio));
           }
        }
      }, 
      cancelarCedulasBD: async function({ peticion }) { 
          let infoProceso = { finalizoSinError: false, cedulasARemover: null };
          try {
              const SERVIDOR = api.conexion;
              const METODO_API_ELIMINAR = api.SINOJ.sistema.consultas.consultaDireccion.CancelarCedulasDireccion;;
              let urlApi = SERVIDOR + METODO_API_ELIMINAR;
              let peticionArchivos = false;
              let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos,false);
              comun.SeEstaCargandoInformacion(true);
              const RESPUESTA_SOLICITUD = await axios.post(urlApi, peticion, headerPeticion);
              const DATOS = await RESPUESTA_SOLICITUD.data;
              let { SiHayError, Error, Satisfactorio, Cedulas } = DATOS;
              if (SiHayError) {
                  let mensajeError = Error.Mensaje;
                  console.log(Error);
                  comun.SeEstaCargandoInformacion(false);
                  console.log(mensajeError);
              } 
              else { 
                  infoProceso = { finalizoSinError: !SiHayError, cedulasARemover: Cedulas };
                  comun.SeEstaCargandoInformacion(false);
                  comun.mensajeDeAlerta(Satisfactorio)
              }
          }
          catch(excepcion) {
              comun.SeEstaCargandoInformacion(false);
              console.log(excepcion);
              comun.mensajeDeAlerta(enumeraciones.error.E500, null, null);
          }
          return infoProceso;
      },
      evtcambiaInfoTodasJurisdicciones: function(cambia){
        this.infoTodasJurisdicciones = cambia;        
      },
      iniciarProcesoCambioFechaDeResultado: async function() { 
          this.resultados.errorEnFechas = !this.campoRequeridoEsValido(this.resultados.fecha);
          if(!this.resultados.errorEnFechas) {
              $("#modal-cambio-fecha-resultado").modal('hide');
              const { fecha } = this.resultados;
              // se crea lista de cedulas con resultado
              this.tablaCedulas.cedulasParaEnviarJuzgado.filter(c => c.enviar).some(c => this.cedulasBD.some(cDB => cDB.CedulaId == c.folio && this.campoRequeridoEsValido(cDB.Resultado)));
              const CEDULAS_SELECCIONADAS = this.tablaCedulas.cedulasParaEnviarJuzgado.filter(c => c.enviar);
              let cedulasObj = this.cedulasBD.filter(cBD => CEDULAS_SELECCIONADAS.some(c => c.folio == cBD.CedulaId) && this.campoRequeridoEsValido(cBD.Resultado)).map(cP => {
                let cedulaObj = cP;
                cedulaObj.Resultado.FechaResultado = fecha;
                return cedulaObj;
              });

              const PETICION_API = { Cedulas: cedulasObj , EsPrueba: false };
              await Promise.resolve(this.modificarFechaDeResultadosBD({ peticion: PETICION_API }));
          }
      },
      modificarFechaDeResultadosBD: async function({ peticion }) { 
          let seObtuvoReporte = false;
          try {
              const SERVIDOR = api.conexion;
              const METODO_API_MODIFICAR = api.SINOJ.sistema.consultas.consultaDireccion.CambiarFechasDeResultado;
              let urlApi = SERVIDOR + METODO_API_MODIFICAR;
              let peticionArchivos = false;
              let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos,false);
              comun.SeEstaCargandoInformacion(true);
              const RESPUESTA_SOLICITUD = await axios.post(urlApi, peticion, headerPeticion);
              const DATOS = await RESPUESTA_SOLICITUD.data;
              let { SiHayError, Error, Satisfactorio } = DATOS;
              if (SiHayError) {
                  let mensajeError = Error.Mensaje;
                  console.log(mensajeError);
                  comun.SeEstaCargandoInformacion(false);
              } 
              else { 
                  comun.SeEstaCargandoInformacion(false);
                  comun.mensajeDeAlerta(Satisfactorio)
              }
          }
          catch(excepcion) {
              comun.SeEstaCargandoInformacion(false);
              console.log(excepcion);
              comun.mensajeDeAlerta(enumeraciones.error.E500, null, null);
          }
          return seObtuvoReporte;
      },
      mostarModalCambioFechaResultado: function() {
        $("#modal-cambio-fecha-resultado").modal('show');
      },
      evtAccionEnSwitchDeFiltros: function(accionRealizada) {
        switch(accionRealizada.tipoDeFiltro) {
            case 'Expediente':
                this.filtrosDeBusquedaSecciones.expediente = accionRealizada.habilitar;
                break;
            case 'Cedula':
                this.filtrosDeBusquedaSecciones.cedula = accionRealizada.habilitar;
                break;
            case 'Fechas':
                this.filtrosDeBusquedaSecciones.fechas = accionRealizada.habilitar;
                break;
            default:
                break;
        };
      },
      iniciarProcesoDeEnvioAJuzgado: async function() {
        try {
          const DIA_ACTUAL = moment().format('YYYY-MM-DD');
          /* if(this.fechaDeEnvioJuzgado < DIA_ACTUAL) {
            this.tablaCedulasSolicitud.mostrarErrorFomulario = true;
          } */
          if(!this.campoRequeridoEsValido(this.fechaDeEnvioJuzgado)) {
            this.tablaCedulasSolicitud.mostrarErrorFomulario = true;
          } 
          else {
            $('#solicitud-cedulas-envio-juzgado').modal('hide');
            let peticion = await Promise.resolve(this.crearPeticionParaEnvioAJuzgado());
            comun.SeEstaCargandoInformacion(true);
            await Promise.resolve(this.enviarCedulasAJuzgado(peticion));
            comun.SeEstaCargandoInformacion(false);
          }
        }
        catch(e) {
          comun.SeEstaCargandoInformacion(false);
          console.log(e);
          comun.mensajeDeAlerta(e);
        }
      },
      informarConfirmacionGenracionDeReporte: function (solicitudCedulasReporte) {
          bootbox.confirm({
              title: "Mensaje del sistema",
              message: `Las cedulas se enviaron correctamente<br><br>Deseas generar el reporte de las cedulas enviadas al juzgado<br>`,
              buttons: {
                  confirm: {
                      label: '<i class="fa fa-check"></i>&nbsp;&nbsp;Si'
                  },
                  cancel: {
                      label: '<i class="fa fa-times"></i>&nbsp;&nbsp;No&nbsp;&nbsp;&nbsp;&nbsp;'
                  }
              },
              callback: async (respuesta) => {
                  if (respuesta) {
                      console.log('solicitudCedulasReporte::',solicitudCedulasReporte);
                      let peticionAPI = await Promise.resolve(this.crearPeticionParaReporteCedulasEnviadas(solicitudCedulasReporte));
                      this.evtCreacionDeReporte(peticionAPI);
                  }
              }
          });
      },
      evtCreacionDeReporte: function(peticionAPI) {
        let peticion = {};
        peticion.EsPrueba = false;
        peticion.SolicitudesDeReportes = JSON.stringify(peticionAPI);        
        peticion.conInformacionCompletaDeCedulas = true;
        const SERVIDOR = api.conexion;
        const METODO_API_OBTENER = api.SINOJ.sistema.reportes.reporteDeDireccion.ObtenerReporteDeDireccion;
        let urlApi = SERVIDOR + METODO_API_OBTENER;
        let peticionArchivos = true;
        //let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos,true);
        let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal);

        comun.SeEstaCargandoInformacion(true);
        axios.post(urlApi, peticion, headerPeticion)
                .then(respuesta => {            
                    if (respuesta.data.SiHayError) {
                        let mensajeError = respuesta.data.Error.Mensaje;
                        console.log(respuesta.data.Error);
                        comun.mensajeDeAlerta(mensajeError, null, null);
                    } 
                    else {
                        const ARCHIVO_DESCARGADO = respuesta.data;
                        //if(ARCHIVO_DESCARGADO != null && ARCHIVO_DESCARGADO.byteLength > 0) {
                        if(respuesta.data.ArchivoBase64 != null) {
                          //  this.visualizadorDelReporte.archivoDeReporte = new File([ARCHIVO_DESCARGADO], 'ReporteCedulasEnviadasAJuzgado', { type: 'application/pdf' });

                            this.EsBase64={
                                  esBase64:true,
                                  archivoBase64:respuesta.data.ArchivoBase64
                            }                            
                            this.visualizadorDelReporte.contRender ++;
                            $('#visualizador-reporte-consultaDireccion').modal('show');
                        }
                        else
                            comun.mensajeDeAlerta('No se encontro información con los parámetros  ingresados en las solicitudes de reporte');
                    }
                    comun.SeEstaCargandoInformacion(false);
                })
                .catch(excepcion => {
                    comun.SeEstaCargandoInformacion(false);
                    console.log(excepcion);
                    comun.mensajeDeAlerta(enumeraciones.error.E500, null, null);
                }
        ); 
      },
      crearPeticionParaReporteCedulasEnviadas: async function(cedulasEnviadas) { 
        let peticionReporte = [];
        cedulasEnviadas.forEach(ce => {
          let juzgadoSeEncuentraEnPeticon = false;
            if(peticionReporte.length > 0)
              juzgadoSeEncuentraEnPeticon = peticionReporte.some(ca => ca.id == ce.Expediente.Juzgado.JuzgadoId);
            // verifica que sea de un juzgado nuevo en la peticion de reporte para no generar reportes duplicados
            if(!juzgadoSeEncuentraEnPeticon) {
              const OBJ_SOLICITUD_REPORTE = {
                indentificadorSolicitud: ce.Expediente.Juzgado.JuzgadoId + this.fechaDeEnvioJuzgado,
                id: ce.Expediente.Juzgado.JuzgadoId,
                juzgado: ce.Expediente.Juzgado.Nombre,
                fechaReporte: this.fechaDeEnvioJuzgado,
                cedulas: cedulasEnviadas.filter(cep => cep.Expediente.Juzgado.JuzgadoId == ce.Expediente.Juzgado.JuzgadoId)
              };
              peticionReporte.push(OBJ_SOLICITUD_REPORTE);
            }
        });
        return peticionReporte;
      },
      crearPeticionParaEnvioAJuzgado: async function() {
        let peticionAPI = {};
        peticionAPI.Cedulas = this.tablaCedulasSolicitud.cedulas.map(c => {
          let cedulaObj = {
            CedulaId: c.Folio,
            FechaDeRegistro: moment().format('YYYY-MM-DD'),
            FechaDeEnvioAJuzgado: this.fechaDeEnvioJuzgado
          }
          return cedulaObj;
        });
        peticionAPI.esPrueba = false;
        return peticionAPI;
      },
      enviarCedulasAJuzgado: async function(peticionAPI) {
        const SERVIDOR = api.conexion;
        const METODO_API_ACTUALIZAR = api.SINOJ.sistema.consultas.consultaDireccion.EnviarCedulasAJuzgado;
        let urlApi = SERVIDOR + METODO_API_ACTUALIZAR;
        let peticionArchivos = false;
        let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos,false);
        axios.post(urlApi, peticionAPI, headerPeticion)
                .then(async (respuesta) => {            
                    if (respuesta.data.SiHayError) {
                        let mensajeError = respuesta.data.Error.Mensaje;
                        console.log(respuesta.data.Error);
                        comun.mensajeDeAlerta(mensajeError, null, null);
                    } 
                    else {
                      // Se limpian variables relacionadas con las solicitudes de envio a juzgado
                      this.tablaCedulas.cedulasParaEnviarJuzgado = [];
                      this.tablaCedulasSolicitud.cedulas = [];
                      this.A_SINOJ_establecerCedulasSeleccionadas_ConsultaDeDireccion([]);
                      this.A_SINOJ_establecerCedulasDeSolicitud_ConsultaDeDireccion([]);
                      this.tablaCedulasSolicitud.mostrarErrorFomulario = false;
                      // se obtienen los resultados actualizados
                      let informarGeneracionReporte = { solicitudes: respuesta.data.Cedulas }
                      // antes de optimizacion this.obtenerCedulasBD(informarGeneracionReporte);
                      // Se actualiza la informacion solo en memoria
                      this.cedulasBD
                        .filter(cDB => informarGeneracionReporte.solicitudes
                        .some(cActalizada => cDB.CedulaId == cActalizada.CedulaId))
                        .map(c => {
                          c.FechaDeEnvioAJuzgado = this.fechaDeEnvioJuzgado;
                          return c;
                        })
                      this.cedulasTabla = this.darFormatoCedulasTabla(this.cedulasBD);
                      this.cedulasTablaConFiltros = this.cedulasTabla;

                      if(this.campoRequeridoEsValido(informarGeneracionReporte))
                        this.informarConfirmacionGenracionDeReporte(informarGeneracionReporte.solicitudes);
                    }
                })
                .catch(excepcion => {
                    console.log(excepcion);
                    comun.mensajeDeAlerta(enumeraciones.error.E500, null, null);
                }
        ); 
      },
      evtSeleccionarCedulaParaSolicitud: function(evento) {
          const CEDULA_ID = evento.folio;
          const ESTADO_SELECCIONADO = evento.enviar;
          const INPUT_CHECK = evento.idCheck;
          const CEDULA_OBJETO = this.cedulasTablaConFiltros.find(c => c.Folio == CEDULA_ID);
          if(ESTADO_SELECCIONADO && CEDULA_OBJETO.FechaDeEnvioAJuzgado != 'Sin enviar') {
            comun.mensajeDeAlerta('La cedula selccionada ya fue enviada a juzgado');
            $('#' + INPUT_CHECK).trigger('click');
          }
      },
      evtLimpiarSolicitudes: function() {
        this.tablaCedulasSolicitud.cedulas = [];
        this.tablaCedulasSolicitud.mostrarErrorFomulario = false;
        this.A_SINOJ_establecerCedulasDeSolicitud_ConsultaDeDireccion(this.tablaCedulasSolicitud.cedulas);
      },
      evtRemoverCedulaDeSolicitud: function(evento) {
        const CEDULA_SELECCIONADA = evento.target.getAttribute('id');
        const CEDULA = CEDULA_SELECCIONADA.split('-');
        const INDEX_ID = (CEDULA.length - 1);
        const ID_CEDULA = CEDULA[INDEX_ID];
        this.tablaCedulasSolicitud.cedulas = this.tablaCedulasSolicitud.cedulas.filter(c => c.Folio != ID_CEDULA);
        this.A_SINOJ_establecerCedulasDeSolicitud_ConsultaDeDireccion(this.tablaCedulasSolicitud.cedulas);
      },
      evtAgregarCedulasASolicitud: function() { 
        let agregoCedulaNuevaASolicitud = false;
        // valida que se encuentre por lo menos una cedula seleccionada
        if(this.tablaCedulas.cedulasParaEnviarJuzgado.filter(cs => cs.enviar).length < 1) {
            comun.mensajeDeAlerta('No se encuentran cedulas seleccionadas');
            return;
        }

        // valida que todas las cedulas seleccionadas no hubiesen sido enviadas al juzgado anteriormente
        if(this.tablaCedulas.cedulasParaEnviarJuzgado.filter(cs => cs.enviar).length > 0) {
          let cedulasEnviadasAnteriormente = 0;
          this.tablaCedulas.cedulasParaEnviarJuzgado
            .filter(cs => cs.enviar)
            .forEach(c => {
              let cedulaEnviada = this.cedulasTablaConFiltros.find(cft => cft.Folio == c.folio);
              if(cedulaEnviada.FechaDeEnvioAJuzgado != 'Sin enviar' || cedulaEnviada.Resultado == 'Sin resultado')
                 cedulasEnviadasAnteriormente ++;
            });
          if(cedulasEnviadasAnteriormente == this.tablaCedulas.cedulasParaEnviarJuzgado.filter(cs => cs.enviar).length) {
            comun.mensajeDeAlerta(`La${ (cedulasEnviadasAnteriormente > 1) ? 's cedulas seleccionadas ya fueron enviadas al juzgado o no cuentan con un resultado' : ' cedula seleccionada ya fue enviada al juzgado o no cuenta con un resultado' }`);
            return;
          }
        }

        this.tablaCedulas.cedulasParaEnviarJuzgado
        .filter(cs => cs.enviar)
        .forEach(c => {
            //console.log('cMemoria::',this.tablaResultadosBusqueda.cedulasMemoria);
            //console.log('cedula::',c)
            let cedulaSelEstaEnlistado = this.cedulasTablaConFiltros.some(cm => cm.Folio == c.folio);
            let fueAgregadaASolicitud = this.tablaCedulasSolicitud.cedulas.some(csl => csl.Folio == c.folio);
            //console.log('cedulaSelEstaEnlistado::' + cedulaSelEstaEnlistado + ' fueAgregadaASolicitud::' + fueAgregadaASolicitud);
            if(cedulaSelEstaEnlistado && !fueAgregadaASolicitud) {
                let cedulaSolicitud = this.cedulasTablaConFiltros.find(cm => cm.Folio == c.folio);
                if(cedulaSolicitud.FechaDeEnvioAJuzgado == 'Sin enviar' && cedulaSolicitud.Resultado != 'Sin resultado') {
                  /*const PROP_PRIORIDAD = "estadoSemaforo";
                  delete cedulaSolicitud[PROP_PRIORIDAD];*/
                  //console.log(cedulaSolicitud)
                  this.tablaCedulasSolicitud.cedulas.push({ 
                    Folio: cedulaSolicitud.Folio, 
                    Juzgado: cedulaSolicitud.Juzgado,
                    Consecutivo: cedulaSolicitud.Consecutivo,
                    TipoDocumento: cedulaSolicitud.TipoDocumento,
                    Domicilio: cedulaSolicitud.Domicilio, 
                    PersonaANotificar: cedulaSolicitud.PersonaANotificar, 
                    TipoCedula: cedulaSolicitud.TipoCedula, 
                    Estatus: cedulaSolicitud.Estatus,
                    Resultado: cedulaSolicitud.Resultado,
                    FechaDeEnvioAJuzgado: cedulaSolicitud.FechaDeEnvioAJuzgado
                    });
                  agregoCedulaNuevaASolicitud = true;
                }
            }
        });
        this.A_SINOJ_establecerCedulasDeSolicitud_ConsultaDeDireccion(this.tablaCedulasSolicitud.cedulas);

        if(!agregoCedulaNuevaASolicitud)
            comun.mensajeDeAlerta('las cedulas seleccionadas ya se encuentran en la lista de solicitudes');
        else
            comun.mensajeDeAlerta('<i class="fas fa-info-circle"></i> Solo cedulas que no hubiesen sido enviadas previamente al juzgado correspondiente y tengan un resultado.<br><br>las cedulas seleccionadas se agregaron correctamente a la solicitud para envio a juzgado');
      },
      evtMostrarConfirmacionEnviarAJuzgado: function() {
        $('#solicitud-cedulas-envio-juzgado').modal('show');
      },
      evtObtenerCedulasSeleccionadas: function(evento) {
        const CEDULAS_TABLA = evento;
        this.tablaCedulas.cedulasParaEnviarJuzgado = CEDULAS_TABLA.filter(c => c.enviar);
      },
      evtDetallesCedula: function(evento) {
        let cedulaSeleccionada = this.obtenerCedulaSeleccionado(evento);
        const VARIBALES_VISTAS_CD = {
          filtrosPrevios: this.FILTROS_BUSQUEDA,
          cedulaSeleccionada: cedulaSeleccionada,
          esNotificador: this.esUsuarioNotificador,
          esJuzgadoMixto: this.usuarioEsDeJuzgadoMixto
        };
        this.A_SINOJ_establecerConsultaDeDireccion_Variables(VARIBALES_VISTAS_CD);
        router.push({ name: "DetallesConsultaDireccion", params: { folio: cedulaSeleccionada.CedulaId } });
      },
      evtCambiarArea: function(evento){ //Cambiar área de jurisdicción        
        this.parametros_Jurisdicciones.cedulaSeleccionada = this.obtenerCedulaSeleccionado(evento);       
        $('#cambiarAreaEncargada_modal').modal('show');
      },
      cambioDeJurisdiccion: function(datos){
        this.parametros_Jurisdicciones.jurisdiccionId = parseInt(datos.target.value);                     
      },
      guardarNuevaAreaEncargada: function(){
          const parametros = {
                EsPrueba: this.enumeraciones.EsPrueba,
                cedulaId: this.parametros_Jurisdicciones.cedulaSeleccionada.CedulaId,
                jurisdiccionId: this.parametros_Jurisdicciones.jurisdiccionId
            }        

            const headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, false);

            axios.post(api.conexion + api.SINOJ.sistema.consultas.consultaDireccion.CambiarJurisdiccion, parametros, headerPeticion)
            .then(respuesta => {
                if (respuesta.data.SiHayError) {
                    console.log(respuesta.data.Error);
                    comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                } else { 
                  $('#cambiarAreaEncargada_modal').modal('hide');
                  comun.mensajeDeAlerta(respuesta.data.Satisfactorio, null, null);
                  this.evtBuscarCedulas();
                  //Se reestablecen valores
                  this.parametros_Jurisdicciones.jurisdiccionId = -1;
                  this.parametros_Jurisdicciones.key = "evtJurisdiccion" + -1;
                }
            })
            .catch(excepcion => {
                console.log(excepcion);
                comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null)
            })
      },       
      obtenerCedulaSeleccionado: function(evento) {
        let cedula = null;
        const CEDULA_SELECCIONADA = evento.target.getAttribute('id');
        const ID_CEDULA = parseInt(this.obtenerCedula(CEDULA_SELECCIONADA));
        this.cedulasBD.filter(cDB => cDB.CedulaId == ID_CEDULA).forEach(c => {
            cedula = c;
        });
        return cedula;
      },
      obtenerCedula: function(cedulaSeleccionada) {
        const CEDULA = cedulaSeleccionada.split('-');
        const POSICION_ID = (CEDULA.length - 1);
        const ID_CEDULA = CEDULA[POSICION_ID];
        return ID_CEDULA;
      },
      obtenerFiltrosDeBusquedaCargados: function() {
        this.FILTROS_BUSQUEDA = {
            Folio: this.$refs[this.REF_FB].numeroDeFolio,
            PartidoJudicialId: this.$refs[this.REF_FB].parametros_PartidoJudicial.partidoJudicialId,
            MateriaId: this.$refs[this.REF_FB].parametros_Materia.materiaId,
            JuzgadoId: this.$refs[this.REF_FB].parametros_Area.areaId,
            TipoDeDocumentoId: this.$refs[this.REF_FB].parametros_TipoDocumento.tipoDocumentoId,
            Consecutivo: this.$refs[this.REF_FB].numeroExtra,
            NumeroDeDocumento: this.$refs[this.REF_FB].consecutivo,
            TipoDeCedulaId: this.tipoCedulaId,
            NotificadorId: this.tipoNotificadorId,
            PersonaANotificar: this.$refs[this.REF_FB].personaANotificar,
            FechaInicial: this.$refs[this.REF_FB].fechaInicial,
            FechaFinal: this.$refs[this.REF_FB].fechaFinal,
            FiltrosHabilitados: this.filtrosDeBusquedaSecciones,
            Estatus: this.$refs[this.REF_FB].filtroEstatus.valorDefinido,
            ConHistorial: this.$refs[this.REF_FB].filtroHistorial.activo,
            FechaAudiencia: this.$refs[this.REF_FB].audiencias.fecha
        }
      },
      evtCambioTipoPrioridad: function(evento) {
        const TIPO_PRIORIDAD_ID = parseInt(evento.target.value);
        this.f_nivelUrgencia = (TIPO_PRIORIDAD_ID > 0) ? TIPO_PRIORIDAD_ID : -1;
        this.filtrarCedulasTabla(null);
      },
      filtrarCedulasTabla: function(e) {
        // filtra por columnas y nivel de prioridad
        this.cedulasTablaConFiltros = this.cedulasTabla
        .filter(c => {
          return Object.values(c).some(valorColumna => this.predicateFiltradoPorSimilitud(valorColumna, this.f_busqueda));
        })
        .filter(c => {
          const NIVEL_PRIORIDAD = this.obtenerIconoDeNivelUrgencia(this.f_nivelUrgencia);
          return this.predicateFiltradoPorPrioridad(c.estadoSemaforo, NIVEL_PRIORIDAD);
        });
        
        /* this.$nextTick(() => {
            const REMOVER_SELECCIONAR_TODO = false;
            this.$refs[this.REF_T_CEDULAS].mostrarSeleccionTodoComponentePadre(REMOVER_SELECCIONAR_TODO);
        }); */
        this.$nextTick(() => {
            this.tablaCedulas.cedulasParaEnviarJuzgado.filter(c => c.enviar).forEach(cedulaSeleccionada => {
                let cedulaEstaEnResultados = this.cedulasTablaConFiltros.some(c => c.Folio == cedulaSeleccionada.folio);
                // console.log('estaEnResultados::',cedulaEstaEnResultados);
                if(cedulaEstaEnResultados)
                    this.$refs[this.REF_T_CEDULAS].seleccionDeCedulaComponentePadre(cedulaSeleccionada.idCheck);
            });
            this.tablaCedulas.cedulasParaEnviarJuzgado = this.$refs[this.REF_T_CEDULAS].cedulasAEnviar;
        });
      },
      predicateFiltradoPorPrioridad: function(elementoAEvaluar,compararCon) { 
        if(this.campoRequeridoEsValido(compararCon)) {
          if(elementoAEvaluar == compararCon)
            return true;
          else
            return false;
        }
        else
            return true;
      },
      predicateFiltradoPorSimilitud: function(elementoAEvaluar,compararCon) { 
        if(this.campoRequeridoEsValido(compararCon)) {
          if(elementoAEvaluar.toString().toUpperCase().startsWith(compararCon.toString().toUpperCase()))
            return true;
          else
            return false;
        }
        else
            return true;
      },
      limpiarFiltrosDeTabla: function() {
        this.f_busqueda = null;
        this.f_nivelUrgencia = -1;
      },
      evtResetearFiltros: function() {
        this.limpiarFiltrosDeTabla();
        this.cedulasTablaConFiltros = this.cedulasTabla;
        this.tablaCedulas.contRender ++;
        this.$nextTick(() => {
            const REMOVER_SELECCIONAR_TODO = false;
            this.$refs[this.REF_T_CEDULAS].mostrarSeleccionTodoComponentePadre(REMOVER_SELECCIONAR_TODO);
        });
        this.tablaCedulas.cedulasParaEnviarJuzgado = [];
      },
      evtBuscarCedulas: function () {
        this.mesajeSinCedulas = (this.mesajeSinCedulas != 'No se encontraron cedulas') ? 'No se encontraron cedulas' : this.mesajeSinCedulas;
        this.limpiarFiltrosDeTabla();
        $("#filtros-input-cedulas-memoria input").off("change paste keyup");
        this.cedulasTablaConFiltros = [];
        //this.cedulaSeleccionada = null;        
        this.obtenerCedulasBD();
      },
      obtenerCedulasBD: async function(generacionDeReporte) { 
        
        const SERVIDOR = api.conexion;
        const METODO_API_OBTENER = api.SINOJ.sistema.consultas.consultaDireccion.ObtenerCedulasConsultaDeDireccion;
        let urlApi = SERVIDOR + METODO_API_OBTENER;
        let peticionArchivos = false;
        let peticionAPI = {
            Folio: (this.campoRequeridoEsValido(this.$refs[this.REF_FB].numeroDeFolio) && this.filtrosDeBusquedaSecciones.cedula) ? this.$refs[this.REF_FB].numeroDeFolio : null,
            PartidoJudicialId: this.campoRequeridoEsValido(this.$refs[this.REF_FB].parametros_PartidoJudicial.partidoJudicialId) && this.filtrosDeBusquedaSecciones.expediente ? this.$refs[this.REF_FB].parametros_PartidoJudicial.partidoJudicialId : null,
            MateriaId: this.campoRequeridoEsValido(this.$refs[this.REF_FB].parametros_Materia.materiaId) && this.filtrosDeBusquedaSecciones.expediente ? this.$refs[this.REF_FB].parametros_Materia.materiaId : null,
            JuzgadoId: this.campoRequeridoEsValido(this.$refs[this.REF_FB].parametros_Area.areaId) && this.filtrosDeBusquedaSecciones.expediente ? this.$refs[this.REF_FB].parametros_Area.areaId : null,
            TipoDeDocumentoId: this.campoRequeridoEsValido(this.$refs[this.REF_FB].parametros_TipoDocumento.tipoDocumentoId) && this.filtrosDeBusquedaSecciones.expediente ? this.$refs[this.REF_FB].parametros_TipoDocumento.tipoDocumentoId : null,
            Consecutivo: this.campoRequeridoEsValido(parseInt(this.$refs[this.REF_FB].numeroExtra)) && this.filtrosDeBusquedaSecciones.expediente ? parseInt(this.$refs[this.REF_FB].numeroExtra) : null,
            NumeroDeDocumento: this.campoRequeridoEsValido(this.$refs[this.REF_FB].consecutivo) && this.filtrosDeBusquedaSecciones.expediente ? this.$refs[this.REF_FB].consecutivo : null,
            TipoDeCedulaId: this.campoRequeridoEsValido(this.tipoCedulaId) && this.filtrosDeBusquedaSecciones.cedula ? this.tipoCedulaId : null,
            NotificadorId: this.campoRequeridoEsValido(this.tipoNotificadorId) && this.filtrosDeBusquedaSecciones.cedula ? this.tipoNotificadorId : null,
            PersonaANotificar: this.campoRequeridoEsValido(this.$refs[this.REF_FB].personaANotificar) && this.filtrosDeBusquedaSecciones.cedula ? this.$refs[this.REF_FB].personaANotificar : null,
            FechaInicial: this.campoRequeridoEsValido(this.$refs[this.REF_FB].fechaInicial) && this.filtrosDeBusquedaSecciones.fechas ? this.$refs[this.REF_FB].fechaInicial : null,
            FechaFinal: this.campoRequeridoEsValido(this.$refs[this.REF_FB].fechaFinal) && this.filtrosDeBusquedaSecciones.fechas ? this.$refs[this.REF_FB].fechaFinal : null,
            Estatus: this.campoRequeridoEsValido(this.$refs[this.REF_FB].filtroEstatus.valorDefinido) && this.filtrosDeBusquedaSecciones.cedula ? this.$refs[this.REF_FB].filtroEstatus.valorDefinido : null,
            ConHistorial: (this.usuarioEsDeJuzgadoMixto) ? true : this.$refs[this.REF_FB].filtroHistorial.activo,
            FechaAudiencia: this.campoRequeridoEsValido(this.$refs[this.REF_FB].audiencias.fecha) && this.filtrosDeBusquedaSecciones.cedula ? this.$refs[this.REF_FB].audiencias.fecha : null,
            esPrueba: false,
            InfoTodasJurisdicciones: this.infoTodasJurisdicciones,
            esUsuarioNotificador: this.esUsuarioNotificador
        }
        let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos,false);
        this.cargandoCedulas = true;
        comun.SeEstaCargandoInformacion(true);
        await axios.post(urlApi, peticionAPI, headerPeticion)
                .then(respuesta => {            
                    if (respuesta.data.SiHayError) {
                        let mensajeError = respuesta.data.Error.Mensaje;
                        console.log(respuesta.data.Error);
                        comun.mensajeDeAlerta(mensajeError, null, null);
                    } 
                    else {
                        console.log('dataCedulas::',respuesta.data.Cedulas)
                        this.cedulasBD = (respuesta.data.Cedulas != null) ? respuesta.data.Cedulas : [];
                        this.cedulasTabla = this.darFormatoCedulasTabla(this.cedulasBD);
                        this.cedulasTablaConFiltros = this.cedulasTabla;
                        if(this.tablaCedulas.hayCedulasSeleccionadas && this.tablaCedulas.cedulasParaEnviarJuzgado.length > 0) {
                          this.$nextTick(() => {
                              this.tablaCedulas.cedulasParaEnviarJuzgado.filter(c => c.enviar).forEach(cedulaSeleccionada => {
                                  let cedulaEstaEnResultados = this.cedulasTablaConFiltros.some(c => c.Folio == cedulaSeleccionada.folio);
                                  // console.log('estaEnResultados::',cedulaEstaEnResultados);
                                  if(cedulaEstaEnResultados)
                                      this.$refs[this.REF_T_CEDULAS].seleccionDeCedulaComponentePadre(cedulaSeleccionada.idCheck);
                              });
                              this.tablaCedulas.cedulasParaEnviarJuzgado = this.$refs[this.REF_T_CEDULAS].cedulasAEnviar;
                          });
                        }
                    }
                    this.cargandoCedulas = false;
                    $("#filtros-input-cedulas-memoria input").on("change paste keyup", (e) => {
                        if(this.cedulasTabla.length > 0 && !this.cargandoCedulas) {
                            this.filtrarCedulasTabla(e);
                        }
                    });
                    this.obtenerFiltrosDeBusquedaCargados();
                    comun.SeEstaCargandoInformacion(false);
                    // informa la confirmacion de generar reporte de cedulas enviadas
                    if(this.campoRequeridoEsValido(generacionDeReporte))
                      this.informarConfirmacionGenracionDeReporte(generacionDeReporte.solicitudes);
                })
                .catch(excepcion => {
                    this.cargandoCedulas = false;
                    //comun.SeEstaCargandoInformacion(false);
                    console.log(excepcion);
                    comun.mensajeDeAlerta(enumeraciones.error.E500, null, null);
                }
        ); 
      },
      darFormatoCedulasTabla: function(cedulas) {
          let cedulasConFormato = [];                       
            
          if(this.infoTodasJurisdicciones){
            if(this.esUsuarioNotificador)
              this.encabezadosColumnas = ['Folio','Juzgado','Consecutivo','Tipo de documento','Domicilio','Persona a notificar', 'Tipo de cédula','Estatus', 'Resultado','Fecha de envio a juzgado', 'Fecha de Asignación','Área de la Jurisdicción'];                         
            else
              this.encabezadosColumnas = ['Folio','Juzgado','Consecutivo','Tipo de documento','Domicilio','Persona a notificar', 'Tipo de cédula','Estatus', 'Resultado','Fecha de envio a juzgado','Área de la Jurisdicción'];
            this.tablaAcciones.check = false;
            this.tablaAcciones.detalles = false;
            this.tablaAcciones.cambiarArea = false;
            this.tablaAcciones.motrarAcciones = false;
          }else{
            if(this.esUsuarioNotificador)
              this.encabezadosColumnas = ['', 'Folio','Juzgado','Consecutivo','Tipo de documento','Domicilio','Persona a notificar', 'Tipo de cédula','Estatus', 'Resultado','Fecha de envio a juzgado', 'Fecha de Asignación', ''];            
            else   
              this.encabezadosColumnas = ['', 'Folio','Juzgado','Consecutivo','Tipo de documento','Domicilio','Persona a notificar', 'Tipo de cédula','Estatus', 'Resultado','Fecha de envio a juzgado', 'Notificador', ''];
            this.tablaAcciones.check = !this.esUsuarioNotificador;
            this.tablaAcciones.detalles = true;
            this.tablaAcciones.cambiarArea = !this.esUsuarioNotificador;
            this.tablaAcciones.motrarAcciones = true;
          }

          if(this.usuarioEsDeJuzgadoMixto)
              this.encabezadosColumnas = this.encabezadosColumnas.filter(e => e != 'Fecha de envio a juzgado'); 

          cedulas.forEach(c => {
            let cedulaFormatoTabla = this.cedulaAObjetoTabla(c);
            cedulasConFormato.push(cedulaFormatoTabla);
          });
          return cedulasConFormato;
      },
      cedulaAObjetoTabla: function(cedula) {
        //'Folio', 'juzgado', 'tipo de documento','consecutivo', 'tipo de cedula', 'estatus', 'resultado'
        //console.log('CEDULA::OBJ::',cedula)
          let cedulaObjTabla = {};    
          if(!this.infoTodasJurisdicciones){            
            cedulaObjTabla.estadoSemaforo = this.obtenerIconoDeNivelUrgencia(cedula.NivelDeUrgencia);
          }          
          cedulaObjTabla.Folio = cedula.CedulaId;
          cedulaObjTabla.Juzgado = (cedula.Expediente.Juzgado != null ) ? cedula.Expediente.Juzgado.Nombre : 'Sin juzgado';
          cedulaObjTabla.Consecutivo = 'Sin consecutivo'; 
          cedulaObjTabla.TipoDocumento = 'Sin documento';
          if(this.campoRequeridoEsValido(cedula.Expediente)) { 
            /* cedulaObjTabla.Juzgado = (cedula.Expediente.Juzgado != null ) ? cedula.Expediente.Juzgado.Nombre : 'Sin juzgado';
             cedulaObjTabla.TipoDocumento = (cedula.Expediente.TipoDocumento != null) ? cedula.Expediente.TipoDocumento.Nombre : 'Sin documento'; */
            cedulaObjTabla.Consecutivo = cedula.Expediente.NumeroDeDocumento; 
            cedulaObjTabla.TipoDocumento = cedula.Expediente.TipoDocumento.Nombre;
          }
          //cedulaObjTabla.Juzgado = 'Sin juzgado';
          cedulaObjTabla.Domicilio = 'Sin Domicilio';
          cedulaObjTabla.PersonaANotificar = 'Sin Persona a Notificar';
          if(this.campoRequeridoEsValido(cedula.PersonasANotificar)) {
            if(cedula.PersonasANotificar[0].Domicilios != null && cedula.PersonasANotificar[0].Domicilios.length > 0) {
                const DOMICILIO_OBJ = cedula.PersonasANotificar[0].Domicilios[0];
                let infAdicionalNumExt = (this.campoRequeridoEsValido(DOMICILIO_OBJ.InformacionAdicionalDeNumeroExterior)) ? ` ${ DOMICILIO_OBJ.InformacionAdicionalDeNumeroExterior }` : '';
                let numInterior = (this.campoRequeridoEsValido(DOMICILIO_OBJ.NumeroInterior)) ? `int ${ DOMICILIO_OBJ.NumeroInterior.toString().trim() }` : '';
                if(this.campoRequeridoEsValido(DOMICILIO_OBJ.Fraccionamiento)) {
                    cedulaObjTabla.Domicilio = `${ DOMICILIO_OBJ.Calle } #${ DOMICILIO_OBJ.NumeroExterior }${ infAdicionalNumExt } ${ numInterior }, ${ DOMICILIO_OBJ.Fraccionamiento.Nombre }, ${ DOMICILIO_OBJ.Fraccionamiento.Municipio.Nombre }`;
                }
                else {
                    /* 
                        para los casos de domicilios con fraccionamiento que no pertenece al catalogo de fraccionamientos, se guarda la informacion el un solo campo (008FraccionamientoFueraDeCatalogo => FraccionamientoFueraDeCatalogo)
                        con el siguiente formato NOMBRE_FRACCIONAMIENTO, NOMBRE_MUNICIPIO, si se modifica posteriormenete este formato se tendra que reemplazar esta 
                        logica.
                      */
                    let fraccionamientoCompuesto = DOMICILIO_OBJ.FraccionamientoFueraDeCatalogo.split(',');
                    let nombreFraccionamiento = fraccionamientoCompuesto[0];
                    let nombreMunicipio = fraccionamientoCompuesto[1];
                    cedulaObjTabla.Domicilio = `${ DOMICILIO_OBJ.Calle } #${ DOMICILIO_OBJ.NumeroExterior }${ infAdicionalNumExt } ${ numInterior }, ${ nombreFraccionamiento }, ${ nombreMunicipio }`;
                }
            }
            
            if(this.campoRequeridoEsValido(cedula.PersonasANotificar[0].DatosGenerales)) {
                const { Fisica, Moral } = cedula.PersonasANotificar[0].DatosGenerales;
                if(this.campoRequeridoEsValido(Fisica))
                    cedulaObjTabla.PersonaANotificar = `${ Fisica.Nombre.toUpperCase().trim() } ${ (this.campoRequeridoEsValido(Fisica.ApellidoPaterno)) ? Fisica.ApellidoPaterno.toUpperCase().trim() : "" }${ (this.campoRequeridoEsValido(Fisica.ApellidoMaterno)) ? (" " + Fisica.ApellidoMaterno.toUpperCase().trim()) : "" }`; 
                else if(this.campoRequeridoEsValido(Moral))
                    cedulaObjTabla.PersonaANotificar = `${ Moral.Nombre.trim() }`; 
            }
          }
          //cedulaObjTabla.TipoDocumento = 'Sin documento';
          cedulaObjTabla.TipoCedula = this.campoRequeridoEsValido(cedula.TipoCedula.Nombre) ? cedula.TipoCedula.Nombre.trim() : 'Sin tipo de cedula.';
          const TIPO_CEDULA_AUDIENCIAS = [1, 10];
          if(TIPO_CEDULA_AUDIENCIAS.some(tc => tc == cedula.TipoCedula.TipoCedulaId)) {
            cedulaObjTabla.TipoCedula += '<br>';
            cedulaObjTabla.TipoCedula += ('<strong>' + moment(cedula.Acuerdos.find(a => a.EsPrincipal).FechaDeAudiencia).format('DD MMMM YYYY hh:mm a') + '</strong>');
          }
          /* cedulaObjTabla.EsAudiencia = 'No';
          if(this.campoRequeridoEsValido(cedula.Expediente)) {
            if(cedula.Expediente.Acuerdos != null && cedula.Expediente.Acuerdos.length > 0) {
              let acuerdoPrincipal = cedula.Expediente.Acuerdos.find(a => a.EsPrincipal);
              if(acuerdoPrincipal != null && acuerdoPrincipal != undefined) {
                cedulaObjTabla.EsAudiencia = this.campoRequeridoEsValido(acuerdoPrincipal.FechaDeAudiencia) ? 'Si' : 'No';
              }
            }
          } */
          cedulaObjTabla.Estatus = cedula.Estatus.Nombre;
          cedulaObjTabla.Resultado = (cedula.Resultado != null) ? cedula.Resultado.TipoResultado.Nombre : 'Sin resultado';
          if(!this.usuarioEsDeJuzgadoMixto)
            cedulaObjTabla.FechaDeEnvioAJuzgado = (this.campoRequeridoEsValido(cedula.FechaDeEnvioAJuzgado)) ? moment(cedula.FechaDeEnvioAJuzgado).format(this.FORMATO_FECHA) : 'Sin enviar';

          if(this.esUsuarioNotificador)
            cedulaObjTabla.FechaDeAsignacion = cedula.AsignacionesDeNotificador != null ? moment(cedula.AsignacionesDeNotificador[0].FechaDeAsignacion).format('DD MMMM YYYY hh:mm a') : '';
            
          if(this.infoTodasJurisdicciones)          
            cedulaObjTabla.NombreAreaJurisdiccion = cedula.Jurisdiccion.Area.Nombre;

          if(!this.infoTodasJurisdicciones && !this.esUsuarioNotificador && !this.usuarioEsDeJuzgadoMixto){
            if(cedula.Notificador != null || cedula.Notificador != undefined){
              cedulaObjTabla.Notificador = cedula.Notificador.Usuario.Nombre 
              + " " + (cedula.Notificador.Usuario.ApellidoPaterno != null ? cedula.Notificador.Usuario.ApellidoPaterno : "")
              + " " + (cedula.Notificador.Usuario.ApellidoMaterno != null ? cedula.Notificador.Usuario.ApellidoMaterno : "");
            } else {
              cedulaObjTabla.Notificador = "";
            }
          }
            
          return cedulaObjTabla;
      },
      obtenerIconoDeNivelUrgencia: function(idEstado) {
        let icono = '';
        switch(idEstado) {
          case enumeraciones.sinoj.estadosNivelDeUrgencia.Rojo:
            icono = `<i class="fa fa-circle text-rigth text-danger" style="font-size: 1.3em;"></i>`;
          break;
          case enumeraciones.sinoj.estadosNivelDeUrgencia.Amarillo:
            icono = `<i class="fa fa-circle text-rigth text-warning" style="font-size: 1.3em;"></i>`;
          break;
          case enumeraciones.sinoj.estadosNivelDeUrgencia.Verde:
            icono = `<i class="fa fa-circle text-rigth text-success" style="font-size: 1.3em;"></i>`;
          break;
          default:
            break;
        }
        return icono;
      },
      evtCambioTipoCedula: function(evento) {
        const TIPO_CEDULA_ID = parseInt(evento.target.value);
        this.tipoCedulaId = (TIPO_CEDULA_ID > 0) ? TIPO_CEDULA_ID : -1;
      },
      evtCambioTipoNotificador: function(evento) { 
        const TIPO_NOTIFICADOR_ID = parseInt(evento.target.value);
        this.tipoNotificadorId = (TIPO_NOTIFICADOR_ID > 0) ? TIPO_NOTIFICADOR_ID : -1;
      },
      campoRequeridoEsValido: function(campo) { 
          let esValido = false
          if(typeof campo === 'string' || campo instanceof String) {
              // valida que filtro tipo cadena no sea nula, indefinida y compuestas solo de espacios en blanco o saltos de linea
              if (campo != null && campo != undefined && campo != '' && campo.replace(/\s/g, '').length) {
                  esValido = true;
              }
          }
          else if (typeof campo === 'number' || campo instanceof Number) {
              // valida que filtro tipo numerico no sea nulo, indefinido y que tengan una valor definido valido (diferente a -1)
              if (campo != null && campo != undefined && campo > 0) {
                  esValido = true;
              }
          }
          else if (typeof campo === 'array' || campo instanceof Array) {
              // valida que filtro tipo numerico no sea nulo, indefinido y que tengan una valor definido valido (diferente a -1)
              if (campo != null && campo != undefined && campo.length > 0) {
                  esValido = true;
              }
          }
          else {
              if (campo != null && campo != undefined) {
                  esValido = true;
              }
          }
          return esValido;
      },
      esJuzgadoMixto: function(areaDeUsuario) {
          if(this.campoRequeridoEsValido(areaDeUsuario)) {
              const { AreaId } = areaDeUsuario;
              const JUZGADOS_MIXTOS = Object.values(enumeraciones.sinoj.juzgadosMixtos);
              if(this.campoRequeridoEsValido(JUZGADOS_MIXTOS)) {
                const ES_JUZGADO_MIXTO = JUZGADOS_MIXTOS.some(jz => jz == AreaId);
                if(ES_JUZGADO_MIXTO) {
                  // se deshabilita la opcion para enviar cedulas al juzgado (por lo general en los juzgados mixtos es la misma persona que hace como juzagdo y direccion de notificadores)
                  this.encabezadosColumnas = this.encabezadosColumnas.filter(e => e != 'Fecha de envio a juzgado');
                  this.tablaAcciones.check = false;
                  this.usuarioEsDeJuzgadoMixto = false;
                }
              }
          }
      },
      asignarValoresUsuarioNotificador: async function() { 
          try {
            const SERVIDOR = api.conexion;
            const METODO_API_OBTENER = api.SINOJ.sistema.consultas.consultaDireccion.ObtenerDatosDeNotificador;
            let urlApi = SERVIDOR + METODO_API_OBTENER;
            let peticionAPI = { esPrueba: false };
            let peticionArchivos = false;
            let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos,false);
            //comun.SeEstaCargandoInformacion(true);
            this.cargandoCedulas = true;
            const PETICION_NOTIFICADOR = await axios.post(urlApi, peticionAPI, headerPeticion);
            const DATOS_PETICION = await PETICION_NOTIFICADOR.data;
            let { SiHayError, Error, Notificador } = DATOS_PETICION;
            if (SiHayError) {
                let mensajeError = Error.Mensaje;
                comun.SeEstaCargandoInformacion(false);
                console.log(mensajeError);
            } 
            else {
                /* this.tablaAcciones = { motrarAcciones: true, check: false, eliminar: false, detalles: true, cambiarArea: false }; */
                const ID_DULCE_KARINA = 46;
                //this.esUsuarioNotificador = (Notificador.NotificadorId != ID_DULCE_KARINA);
                this.parametrosReporteCedulasPendientes.notificadorId = Notificador.NotificadorId;
                /* this.encabezadosColumnas = ['Folio','Consecutivo','Tipo de documento','Domicilio','Persona a notificar', 'Tipo de cédula','Estatus', 'Resultado','Fecha de envio a juzgado'];
                this.tablaAcciones = { motrarAcciones: false, check: false, eliminar: false, detalles: false, cambiarArea: false }; */
                /*this.tipoNotificadorId = Notificador.NotificadorId;
                this.$refs[this.REF_FB].parametros_Notificadores.esInformativo = this.campoRequeridoEsValido(Notificador.NotificadorId) ? true : false;
                this.$refs[this.REF_FB].parametros_Notificadores.valorDefinido = Notificador.NotificadorId;
                this.$refs[this.REF_FB].parametros_Notificadores.key = 'CFTNVCD' + this.contadorRenderFiltros; */
                //comun.SeEstaCargandoInformacion(false);
            }
          }
          catch(excepcion) {
              //comun.SeEstaCargandoInformacion(false);
              console.log(excepcion);
              comun.mensajeDeAlerta(enumeraciones.error.E500, null, null);
          }
      },
      ...mapActions([
        'A_SINOJ_establecerConsultaDeDireccion_Variables',
        'A_SINOJ_establecerCedulasSeleccionadas_ConsultaDeDireccion',
        'A_SINOJ_establecerCedulasDeSolicitud_ConsultaDeDireccion'
      ])   
    },
    async mounted() { 
      if(this.campoRequeridoEsValido(this.$store.state.Login_Usuario.Area)) {
          this.cargoAreaDeUsuario = true;
          this.esJuzgadoMixto(this.$store.state.Login_Usuario.Area);          
      }

      if(this.FILTROS_CARGADOS_PREVIAMENTE != null && this.FILTROS_CARGADOS_PREVIAMENTE != undefined) {
        // renderizar catalogos de componente hijo filtrosDeBusqueda con valor elegido previamente
        //console.log('mounted::fiall::',this.FILTROS_CARGADOS_PREVIAMENTE);
        if(this.FILTROS_CARGADOS_PREVIAMENTE.cargarConFiltros) {
            const TIPOS_AUDIENCIAS_IDS = [1, 10];
            // se asignan los valores de los filtros 
            this.$refs[this.REF_FB].numeroDeFolio = this.FILTROS_CARGADOS_PREVIAMENTE.Folio;
            this.$refs[this.REF_FB].parametros_PartidoJudicial.partidoJudicialId = this.FILTROS_CARGADOS_PREVIAMENTE.PartidoJudicialId;
            this.$refs[this.REF_FB].parametros_Materia.materiaId = this.FILTROS_CARGADOS_PREVIAMENTE.MateriaId;
            this.$refs[this.REF_FB].parametros_Area.areaId = this.FILTROS_CARGADOS_PREVIAMENTE.JuzgadoId;
            this.$refs[this.REF_FB].parametros_TipoDocumento.tipoDocumentoId = this.FILTROS_CARGADOS_PREVIAMENTE.TipoDeDocumentoId;
            if(this.FILTROS_CARGADOS_PREVIAMENTE.TipoDeDocumentoId == enumeraciones.pj.tiposDocumento.Terceria || this.FILTROS_CARGADOS_PREVIAMENTE.TipoDeDocumentoId == enumeraciones.pj.tiposDocumento.Incidente) {
              this.$refs[this.REF_FB].numeroExtra = this.FILTROS_CARGADOS_PREVIAMENTE.Consecutivo;
              this.$refs[this.REF_FB].mostrarNumeroExtra = true;
            }
            this.$refs[this.REF_FB].consecutivo = this.FILTROS_CARGADOS_PREVIAMENTE.NumeroDeDocumento;
            this.$refs[this.REF_FB].personaANotificar = this.FILTROS_CARGADOS_PREVIAMENTE.PersonaANotificar;
            this.$refs[this.REF_FB].fechaInicial = this.FILTROS_CARGADOS_PREVIAMENTE.FechaInicial;
            this.$refs[this.REF_FB].fechaFinal = this.FILTROS_CARGADOS_PREVIAMENTE.FechaFinal;
            this.$refs[this.REF_FB].filtroHistorial.activo = this.FILTROS_CARGADOS_PREVIAMENTE.ConHistorial;
            this.$refs[this.REF_FB].filtroEstatus.valorDefinido = this.FILTROS_CARGADOS_PREVIAMENTE.Estatus;
            this.$refs[this.REF_FB].audiencias.activo = TIPOS_AUDIENCIAS_IDS.some(ta => ta == this.tipoCedulaId);
            this.$refs[this.REF_FB].audiencias.fecha = (this.$refs[this.REF_FB].audiencias.activo) ? this.FILTROS_CARGADOS_PREVIAMENTE.FechaAudiencia : null;
            // se actualizan los catalogos
            this.$refs[this.REF_FB].parametros_PartidoJudicial.key = 'CFPRJVCD' + this.contadorRenderFiltros;
            this.$refs[this.REF_FB].parametros_Materia.key = 'CFMTVCD' + this.contadorRenderFiltros;
            this.$refs[this.REF_FB].parametros_Area.key = 'CFJZVCD' + this.contadorRenderFiltros;
            this.$refs[this.REF_FB].parametros_TipoDocumento.key = 'CFTDVCD' + this.contadorRenderFiltros;
            this.$refs[this.REF_FB].parametros_TiposCedula.valorDefinido = this.tipoCedulaId;
            this.$refs[this.REF_FB].parametros_TiposCedula.key = 'CFTCVCD' + this.contadorRenderFiltros;
            this.$refs[this.REF_FB].parametros_Notificadores.valorDefinido = this.tipoNotificadorId;
            this.$refs[this.REF_FB].parametros_Notificadores.key = 'CFTNVCD' + this.contadorRenderFiltros;
            this.$refs[this.REF_FB].filtroEstatus.key = 'CFTESTDCEDULA' + this.contadorRenderFiltros;
            this.contadorRenderFiltros += 1;

            //carga los valores de los switch para la deshabilitacion de filtros
            if(this.FILTROS_CARGADOS_PREVIAMENTE.FiltrosHabilitados != null) {
              const { expediente, cedula, fechas } = this.FILTROS_CARGADOS_PREVIAMENTE.FiltrosHabilitados;
              // switch filtros expediente
              if(expediente)
                this.$refs[this.REF_FB].evtHabilitarFiltros('Expediente');
              else
                this.$refs[this.REF_FB].evtDeshabilitarFiltros('Expediente');
              // switch filtros cedula
              if(cedula)
                this.$refs[this.REF_FB].evtHabilitarFiltros('Cedula');
              else
                this.$refs[this.REF_FB].evtDeshabilitarFiltros('Cedula');
              // switch filtros fechas
              if(fechas)
                this.$refs[this.REF_FB].evtHabilitarFiltros('Fechas');
              else
                this.$refs[this.REF_FB].evtDeshabilitarFiltros('Fechas');
            }

            if(this.obtenerCedulas){
              comun.SeEstaCargandoInformacion(true);
              await Promise.resolve(this.obtenerCedulasBD());
              comun.SeEstaCargandoInformacion(false);
            }
            else
              this.FILTROS_BUSQUEDA = null;
        }        
      }
      
      await Promise.resolve(this.asignarValoresUsuarioNotificador());

      this.cargandoCedulas = false;      
      //comun.SeEstaCargandoInformacion(false);
      this.FILTROS_CARGADOS_PREVIAMENTE = null;
      //this.FILTROS_BUSQUEDA = null;
    },
    created() {
      this.FILTROS_CARGADOS_PREVIAMENTE = this.campoRequeridoEsValido(this.obtenerFiltrosPreviosBusqueda) ? this.obtenerFiltrosPreviosBusqueda[this.ATRIBUTO_FILTROS] : null;
      this.BANDERA_OBTENER_CEDULAS = this.campoRequeridoEsValido(this.obtenerFiltrosPreviosBusqueda) ? this.obtenerFiltrosPreviosBusqueda["obtenerCedulas"] : false;
      if(this.FILTROS_CARGADOS_PREVIAMENTE != null && this.FILTROS_CARGADOS_PREVIAMENTE != undefined) {
        if(this.FILTROS_CARGADOS_PREVIAMENTE.cargarConFiltros) {
            //console.log(this.BANDERA_OBTENER_CEDULAS);
            this.tipoCedulaId = this.FILTROS_CARGADOS_PREVIAMENTE.TipoDeCedulaId;
            this.tipoNotificadorId = this.FILTROS_CARGADOS_PREVIAMENTE.NotificadorId;
            this.obtenerCedulas = this.BANDERA_OBTENER_CEDULAS;
        }
      }
      //console.log('Cedulas::previas::',this.obtenerSolicitudDeCedulasPrevia);
      if(this.obtenerSolicitudDeCedulasPrevia != null || this.obtenerSolicitudDeCedulasPrevia.length > 0) {
        this.tablaCedulasSolicitud.cedulas = this.obtenerSolicitudDeCedulasPrevia;
      }
      if(this.obtenerCedulasSeleccionadasPrevias != null && this.obtenerCedulasSeleccionadasPrevias.length > 0) {
        this.tablaCedulas.cedulasParaEnviarJuzgado = this.obtenerCedulasSeleccionadasPrevias;
        this.tablaCedulas.hayCedulasSeleccionadas = true;
      }
      this.A_SINOJ_establecerConsultaDeDireccion_Variables(null);

      // Filtros de areas.
      let filtrosAreas = areasAFiltrarParaDireccion({ areaDireccion: this.$store.state.Login_Usuario.Area.AreaId, conDireccion: false });

      if(filtrosAreas.elementosAOmitir != undefined || filtrosAreas.elementosAOmitir != null)
        Array.prototype.push.apply(this.elementosAOmitir.areas, filtrosAreas.elementosAOmitir);

      if(filtrosAreas.elementosAConservar != undefined || filtrosAreas.elementosAConservar != null)
        this.elementosAConservar.areas =  filtrosAreas.elementosAConservar;
    },
    computed: {
      obtenerFiltrosPreviosBusqueda() {
        return this.$store.getters.Get_SINOJ_ConsultaDeDireccion_Variables;
      },
      obtenerCedulasSeleccionadasPrevias() {
        return this.$store.getters.Get_SINOJ_CedulasSeleccionadas_ConsultaDeDireccion;
      },
      obtenerSolicitudDeCedulasPrevia() {
        return this.$store.getters.Get_SINOJ_CedulasDeSolicitud_ConsultaDeDireccion;
      },
      cedulaSeleccionadaConResultado() {
        return this.tablaCedulas.cedulasParaEnviarJuzgado.filter(c => c.enviar).some(c => this.cedulasBD.some(cDB => cDB.CedulaId == c.folio && this.campoRequeridoEsValido(cDB.Resultado)));
      },
    },
    watch: {
        'tablaCedulas.cedulasParaEnviarJuzgado': function() {
            this.A_SINOJ_establecerCedulasSeleccionadas_ConsultaDeDireccion(this.tablaCedulas.cedulasParaEnviarJuzgado);
            let todosLosElementosSeleccionados = (this.tablaCedulas.cedulasParaEnviarJuzgado.filter(c => c.enviar).length == this.cedulasTablaConFiltros.length);
            this.$refs[this.REF_T_CEDULAS].mostrarSeleccionTodoComponentePadre(todosLosElementosSeleccionados);
        },
        '$store.state.Login_Usuario.Area': function() {
            this.$nextTick(() => {          
                if(this.campoRequeridoEsValido(this.$store.state.Login_Usuario.Area) && !this.cargoAreaDeUsuario) { 
                    this.cargoAreaDeUsuario = true;
                    this.esJuzgadoMixto(this.$store.state.Login_Usuario.Area);
                }
            });
        }
    },
    beforeRouteLeave (to, from, next) {
        const VISTA_HIJA = 'DetallesConsultaDireccion';
        if(to.name != VISTA_HIJA) {
          this.A_SINOJ_establecerConsultaDeDireccion_Variables(null);
          this.A_SINOJ_establecerCedulasSeleccionadas_ConsultaDeDireccion([]);
          this.A_SINOJ_establecerCedulasDeSolicitud_ConsultaDeDireccion([]);
        }
        next();
    }
  }
</script>
<style scoped>
    #filtros-memoria-cedulas-vcdd input, #filtros-memoria-cedulas-vcdd select {
      background-color: rgb(224, 224, 224) !important;
      color: #1b1919 !important;
    }

    #filtros-memoria-cedulas-vcdd .form-control::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
      color: #858585 !important;
      opacity: 1; /* Firefox */
    }

    #filtros-memoria-cedulas-vcdd .form-control:-ms-input-placeholder { /* Internet Explorer 10-11 */
      color: #858585 !important;
    }

    #filtros-memoria-cedulas-vcdd .form-control::-ms-input-placeholder { /* Microsoft Edge */
      color: #858585 !important;
    }

    #encabezados-tp {
        margin-bottom: 1em;
    }

    #encabezados-tp h1 {
        margin-bottom: 0;
        font-weight: bold;
    }

    #encabezados-tp h4 {
        font-size: 1.5em;
        color: rgb(214, 214, 214);
    }

    .hr-titulo {
        height:0.5em;
        width: 6em;
        border:none;
        background-color:#ffffff;
    }

    #ConsultaDireccion_div .card-header {
        background-color: rgb(70, 70, 70);
    }

    #ConsultaDireccion_div .card-body {
        background-color: rgb(49, 49, 49);
    }

    #ConsultaDireccion_div .card {
        border: 1px solid rgb(129, 129, 129) !important;
    }

#visualizador-reporte-notificador-pendientes-VCDDIR .modal-lg {
    max-width: 70% !important;
}

#visualizador-reporte-notificador-pendientes-VCDDIR .modal-header {
    background-color: rgb(36, 34, 34);;
    border: none;
}

#creacion-reporte-cedulas-pendientes-notificador .modal-lg {
    max-width: 40% !important;
}

#creacion-reporte-cedulas-pendientes-notificador .modal-header {
    background-color: rgb(36, 34, 34);
    border: none;
}

#creacion-reporte-cedulas-pendientes-notificador .modal-dialog {
    position: relative;
    top: 40%;
    transform: translateY(-50%);
}

#creacion-reporte-cedulas-pendientes-notificador .modal-footer {
    border-top-width: 0.1em;
    border-top-color: rgb(29, 29, 29);
    padding-top: 0.8em;
    padding-bottom: 0.8em;
}

#modal-confirmacion-cancelacion-cedulas .modal-lg {
    max-width: 50% !important;
}

#modal-confirmacion-cancelacion-cedulas .modal-header {
    background-color: rgb(36, 34, 34);
    border: none;
}

#modal-confirmacion-cancelacion-cedulas .modal-dialog {
    position: relative;
    top: 40%;
    transform: translateY(-50%);
}

#modal-confirmacion-cancelacion-cedulas .modal-footer {
    border-top-width: 0.1em;
    border-top-color: rgb(29, 29, 29);
    padding-top: 0.8em;
    padding-bottom: 0.8em;
}


.seccion-acciones .btn-danger:hover, .seccion-acciones .btn-danger:focus{
  color: #fff !important;
  background-color: #dc3545 !important;
  border-color: #dc3545 !important;
}

.seccion-acciones .btn span {
  display: none;
  font-size: 0.9em;
}

.seccion-acciones .btn:hover span {
  display: inline-block;
}

.contenedor-aviso-sin-resultados {
      background-color: rgb(24, 23, 23);
      height: 21rem;
      display: flex;
      align-items: center;
      justify-content: center;
      border: 1px solid black;
  }

.seccion-acciones {
  margin-top: -1em;
}

.seccion-acciones .btn {
  font-size: 1.1rem !important;
  padding: 0.2em 0.5em 0.1em 0.5em !important;
}

.seccion-acciones .btn-light {
  background-color: rgb(224, 224, 224);
  color: black;
  border-color: #2c2d31;
}

.seccion-acciones .btn-danger {
  color: #212529;
  background-color: rgb(224, 224, 224);
  border-color: #f8f9fa;
}

.seccion-acciones .btn-light:hover, .seccion-acciones .btn-light:focus{
  color: #fafafa;
  background-color: #636363;
  border-color: #636363;
}

#contenedor-inf-reporte-general h6 {
    font-size: 1.1em;
    color: rgb(27, 27, 27);
}

#modal-cambio-fecha-resultado .modal-lg {
    max-width: 40% !important;
}

#modal-cambio-fecha-resultado .modal-header {
    background-color: rgb(36, 34, 34);
    border: none;
}

#modal-cambio-fecha-resultado .modal-dialog {
    position: relative;
    top: 40%;
    transform: translateY(-50%);
}

#modal-cambio-fecha-resultado .modal-footer {
    border-top-width: 0.1em;
    border-top-color: rgb(29, 29, 29);
    padding-top: 0.8em;
    padding-bottom: 0.8em;
}

@media screen and (max-width: 800px) {
  #filtros-memoria-cedulas-vcdd {
    /* flex-direction: column !important; */
  }

  #filtros-input-cedulas-memoria {
    flex-direction: column !important;
    margin-bottom: 10px !important;
    margin-right: 0px !important;
  }

  #filtros-nivel-urgencia {
    flex-direction: column !important;
    margin-bottom: 10px !important;
    margin-right: 0px !important;
  }

  #filtros-nivel-urgencia select{
    width: 100% !important;
  }

  #filtros-input-cedulas-memoria input {
    width: 100% !important;
  }

  .f-item {
    width: 100% !important;
  }

  #filtros-memoria-cedulas-vcdd .btn-sm {
    width: 100% !important;
  } 
}

#filtros-memoria-cedulas-vcdd .btn-sm {
  cursor: pointer;
  background-color: rgb(27, 25, 25);
  padding: 5px 15px 5px 15px;
} 

#filtros-memoria-cedulas-vcdd .btn-sm:hover, #filtros-memoria-cedulas-vcdd .btn-sm:focus {
  background-color: black;
}

#filtros-memoria-cedulas-vcdd .form-control::-webkit-input-placeholder { color: rgb(201, 192, 192); }  /* WebKit, Blink, Edge */
#filtros-memoria-cedulas-vcdd .form-control:-moz-placeholder { color:  rgb(201, 192, 192); }  /* Mozilla Firefox 4 to 18 */
#filtros-memoria-cedulas-vcdd .form-control::-moz-placeholder { color:  rgb(201, 192, 192); }  /* Mozilla Firefox 19+ */
#filtros-memoria-cedulas-vcdd .form-control:-ms-input-placeholder { color:  rgb(201, 192, 192); }  /* Internet Explorer 10-11 */
#filtros-memoria-cedulas-vcdd .form-control::-ms-input-placeholder { color:  rgb(201, 192, 192); }  /* Microsoft Edge */

.contenedor-color-negro {
    padding: 1.5em;
    background-color: #2c2d31;
    box-shadow: 0px 6px 20px 8px #161616;
}

.contenedor-sin-cedula {
    background-color: rgb(36, 34, 34);
    height: 40px;
    height: 21rem;
    display: flex;
    align-items: center;
    justify-content: center;
}

.contenedor-cargando {
    background-color: rgb(36, 34, 34);
    height: 40px;
    height: 21rem;
    display: flex;
    align-items: center;
    justify-content: center;
}

#encabezado-contenedor-contenido {
  background-color: rgb(44, 43, 43);
  padding: 10px;
}

#encabezado-contenedor-contenido .btn {
  background-color: black;
  padding-left: 15px;
  padding-right: 15px;
}

.contenedor-informacion {
  background-color: #323335;
  padding: 1vw 2vw 1vw 2vw;
}

.texto-ajustable-btn {
    font-size: 1vw;
}

#solicitud-cedulas-envio-juzgado .modal-lg {
    max-width: 70% !important;
}

#solicitud-cedulas-envio-juzgado .modal-header {
    background-color: rgb(36, 34, 34);;
    border: none;
}

#accion-eliminar-solicitudes {
    cursor: pointer;
}

 #contenedor-error-formulario {
      padding: 1em;
      background-color: #26272b;
      border: 1px solid #5c5959;
      border-radius: 8px;
      margin-bottom: 1em;;
  }

  
#visualizador-reporte-consultaDireccion .modal-lg {
    max-width: 70% !important;
}

#visualizador-reporte-consultaDireccion .modal-header {
    background-color: rgb(36, 34, 34);;
    border: none;
}
</style>



// WEBPACK FOOTER //
// src/components/SINOJ/Consultas/ConsultaDireccion/ConsultaDireccion.vue